// import Push from 'push.js';
import * as PusherPushNotifications from "@pusher/push-notifications-web"
import { CountUp } from "countup.js";

// VARIABLES
!function ($) {
    "use strict";

    // Constructor of class
    var Variables = function() {

    };


    Variables.prototype.dateRangePickerOptions = () => {
        return {
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            // minDate: '01/01/2000',
            // maxDate: '12/31/2016',
            // dateLimit: {
            //     days: 60
            // },
            showDropdowns: true,
            showWeekNumbers: false,
            timePicker: false,
            timePickerIncrement: 1,
            timePicker12Hour: true,
            ranges: $.Variables.dateRangePickerRange(),
            opens: 'center',
            drops: 'auto',
            buttonClasses: ['btn', 'btn-sm'],
            applyClass: 'btn-success',
            cancelClass: 'btn-danger',
            separator: ' hingga ',
            locale: {
                format: 'DD MMM YYYY',
                applyLabel: 'Terapkan',
                cancelLabel: 'Batal',
                fromLabel: 'dari',
                toLabel: 'ke',
                customRangeLabel: 'Custom',
                daysOfWeek: ['Mgg', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
                monthNames: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
                firstDay: 1
            }
        }
    },

    /**
     * Daterange picker's range
     * return array
     */
    Variables.prototype.dateRangePickerRange = () => {
        return {
            'Bulan ini': [moment().startOf('month'), moment().endOf('day')],
            '1 Bulan Lalu': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            '2 Bulan Lalu': [moment().subtract(2, 'month').startOf('month'), moment().subtract(2, 'month').endOf('month')],
            '3 Bulan Lalu': [moment().subtract(3, 'month').startOf('month'), moment().subtract(3, 'month').endOf('month')],
            '30 Hari Terakhir': [moment().subtract(30, 'day'), moment().endOf('day')],
            '90 Hari Terakhir': [moment().subtract(90, 'day'), moment().endOf('day')],
            'Tahun Ini': [moment().startOf('year'), moment().endOf('day')],
            'Tahun Kemarin': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
        }
    },

    /**
     * Daterange picker's range
     * return array
     */
    Variables.prototype.dateRangePickerRangeSingle = () => {
        return {
            'Bulan ini': [moment().startOf('month')],
            '1 Bulan Lalu': [moment().subtract(1, 'month').startOf('month')],
            '2 Bulan Lalu': [moment().subtract(2, 'month').startOf('month')],
            '3 Bulan Lalu': [moment().subtract(3, 'month').startOf('month')],
            '6 Bulan Lalu': [moment().subtract(6, 'month').startOf('month')],
            'Tahun Lalu': [moment().subtract(1, 'year').startOf('year')],
            '2 Tahun Lalu': [moment().subtract(2, 'year').startOf('year')],
            '3 Tahun Lalu': [moment().subtract(3, 'year').startOf('year')],
            '5 Tahun Lalu': [moment().subtract(5, 'year').startOf('year')],
        }
    },

    /**
     * Get SWAL width
     */
    Variables.prototype.swalWidth = () => {
        // Used for custom SWAL
        let responsiveWidth = $(window).width();
        let swalWidth = responsiveWidth * .75; // init
        if (responsiveWidth > 991) {
            // lg
            swalWidth = 0.45 * responsiveWidth;
        } else if (responsiveWidth > 768) {
            // md
            swalWidth = 0.65 * responsiveWidth;
        } else if (responsiveWidth > 575) {
            // sm
            swalWidth = 0.75 * responsiveWidth;
        } else if (responsiveWidth > 400) {
            // xs
            swalWidth = 0.86 * responsiveWidth;
        } else {
            // xxs
            swalWidth = 0.95 * responsiveWidth;
        }
        return swalWidth;
    },


    /**
     * Return context page that not includes (page login, page logout)
     * @return bool (true = is on page exception, false = can activate rest of commands )
     */
    Variables.prototype.checkViewNotInclude = () => {
        // Login and logout will not run
        const viewNotInlcude = [
            'login',
            'logout',
        ];
        if (typeof view == 'undefined' || (view && view.includes(viewNotInlcude))) {
            return true;
        }

        return false;
    },


    Variables.prototype.countUpDuration = 0.3,

    $.Variables = new Variables, $.Variables.Constructor = Variables

}(window.jQuery),



// COMPONENTS
!function ($) {
    "use strict";

    var Components = function () { 

    };

    // custom components
    Components.prototype.initSelect2readonly = function () {
        // select2 readonly open disabler
        if(jQuery.fn.select2) {
            let allSelect2 = $('.content').find('.select2');
            if (allSelect2.length > 0) {
                $.each(allSelect2, function () {
                    let $select2 = $(this);
                    $select2.unbind('select2:open.readonly'); // unbind to stop multiple triggering bug
                    $select2.on('select2:open.readonly', function () {
                        let $this = $(this);
                        if ($this.prop('readonly')) {
                            $this.select2('close');
                        }
                    })
                    $select2.removeClass('readonly');
                    if ($select2.prop('readonly')) {
                        $select2.addClass('readonly'); // add custom class readonly for changing color
                    }
                })
            }
        }
        
    },

    // select2 disable
    Components.prototype.initSelect2disabled = function() {
        if(jQuery.fn.select2) {
            let $allSelect2 = $('.content').find('.select2');
            if ($allSelect2.length > 0) {
                $.each($allSelect2, function () {
                    let $select2 = $(this);
                    if ($select2.prop('disabled')) {
                        $select2
                            .select2({ disabled: true })
                            .trigger('change.select2');
                    }
                })
            }
        }
    },

    //initilizing
    Components.prototype.init = function () {
        var $this = this;
        // custom components
        this.initSelect2readonly();
        this.initSelect2disabled();


        $('.form-select').on('select2:clear', function(e){
            $(this).val([]);
        })
    },

    $.Components = new Components, $.Components.Constructor = Components

}(window.jQuery),



// APP
function ($) {
    'use strict';

    var App = function () {
        this.$body = $('body'),
        this.$window = $(window)
    };


    /**
     * Generate UUID
     */
    App.prototype.generateUUID = () => {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); // use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },


    /**
     * Activating trigger keyup remove form control error/invalid
     */
    App.prototype.triggerRemoveFormControlError = () => {
        // By form controls
        let $formControls = $('.form-control, .form-select');
        // for(let i = 0; i < $formControls.length; i++) {
        //     let $formControl = $($formControls[i]);
        //     $formControl.on('change.removeInvalid keyup.removeInvalid select2:open.removeInvalid focus.removeInvalid', function (e) {
        //         let $this = $(e.currentTarget);
        //         let $formGroups = $this.closest('.form-group, .fv-row')
        //         for (let j = 0; j < $formGroups.length; j++) {
        //             // Get each .form-group or .fv-row and seek for invalid-feedback
        //             let $invalidResponse = $($formGroups[j]).find('.invalid-feedback');
        //             // Check if there is an error message
        //             $invalidResponse.fadeOut(300, null, function () {
        //                 $invalidResponse.remove();
        //             })
        //         }

        //         // Remove .is-invalid on this.form-control
        //         if ($this.hasClass('is-invalid')) {
        //             $this.removeClass('is-invalid');
        //         } else {
        //             // remove the effect immediate
        //             $this.off('change.removeInvalid keyup.removeInvalid select2:open.removeInvalid focus.removeInvalid');
        //         }
        //     })
        //     // console.log($formControl.parent().find('.invalid-feedback'));
        // }


        // Using $content observer method
        $content.on('change.removeInvalid keyup.removeInvalid select2:open.removeInvalid focus.removeInvalid', '.form-control, .form-select', function (e) {
            let $this = $(e.currentTarget);
            let $formGroups = $this.closest('.form-group, .fv-row')
            for (let j = 0; j < $formGroups.length; j++) {
                // Get each .form-group or .fv-row and seek for invalid-feedback
                let $invalidResponse = $($formGroups[j]).find('.invalid-feedback');
                // Check if there is an error message
                $invalidResponse.fadeOut(300, null, function () {
                    $invalidResponse.remove();
                })
            }

            // Remove .is-invalid on this.form-control
            if ($this.hasClass('is-invalid')) {
                $this.removeClass('is-invalid');
            } else {
                // remove the effect immediate
                $this.off('change.removeInvalid keyup.removeInvalid select2:open.removeInvalid focus.removeInvalid');
            }
        })
    },


    /**
     * Remove all script with variables <script variables>...</script>
     */
    App.prototype.removeScriptVariable = () => {
        setTimeout(() => {
            let $scripts = $('script[variables], script[variable]');
            if ($scripts && $scripts.length > 0) {
                $.each($scripts, (i, el) => {
                    let $this = $(el);
                    $this.remove();
                });
            }
        }, 500);
    },


    /**
     * Trigger input mask
     */
    App.prototype.inputMask = () => {
        // Email input mask
        let $inputEmail = $('[type="email"]');
        for (let i = 0; i < $inputEmail.length; i++) {
            let $this = $($inputEmail[i]);
            let a = Inputmask({
                mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
                greedy: false,
                onBeforePaste: function (pastedValue, opts) {
                    pastedValue = pastedValue.toLowerCase();
                    return pastedValue.replace("mailto:", "");
                },
                definitions: {
                    "*": {
                        validator: '[0-9A-Za-z!#$%&"*+/=?^_`{|}~\-]',
                        cardinality: 1,
                        casing: "lower"
                    }
                }
            }).mask($this[0]);
            // console.log(a, $this[0]);
        }
    },



    /**
     * Encode an URL using javascript to be same as PHP method
     * @param {*} url 
     * @returns 
     */
    App.prototype.urlencode = (url) => {
        return encodeURIComponent(url).replace(/%20/g, '+');
    },


    /**
     * Set overlay loading
     * @param {*} is_loading 
     */
    App.prototype.overlayLoading = (is_loading = false) => {
        if ($overlayLayer && $overlayLayer.length > 0) {
            if (!is_loading) {
                $overlayLayer.hide();
                $content.find('.container-fluid, .container-xxl, .container-xl, .container').removeClass('overlay overlay-block');
            } else {
                $overlayLayer.show();
                $content.find('.container-fluid, .container-xxl, .container-xl, .container').addClass('overlay overlay-block');
            }
        }
    },


    /**
     * If the URL uses {route_url} + ? ... then remove it
     * This makes the URL clear and hides the params
     */
    App.prototype.removeUrlGetModifier = () => {
        let real_url = window.location.href; // with also get params
        let now_url = window.location.origin + window.location.pathname; // the real url without get params
        if (real_url.indexOf('?') > -1) {
            // if(history.pushState) {
            //     window.history.pushState({ path: now_url }, '', now_url);
            // } else {
            //     window.history.replaceState({ path: now_url }, '', now_url);
            // }
            window.history.replaceState({ path: now_url }, '', now_url);
        }
    },


    /**
     * Aliases
     */
    App.prototype.removeUrlGet = () => {
        return $.App.removeUrlGetModifier();
    },



    /**
     * Error Handling on ajax button submit
     * 
     * @param {*} data 
     */
    App.prototype.errorHandling = (data) => {
        if (data) {
            if (data.responseJSON) {
                if (data.responseJSON.message == 'CSRF token mismatch.') {
                    toastr.warning("Token csrf tidak dapat tervalidasi. Memuat halaman kembali...", "CSRF Error");
                    setTimeout(function () {
                        window.location.reload(true);
                    }, 1000);
                } else if (data.responseJSON.message == 'The given data was invalid.') {
                    toastr.error("Data form yang dikirimkan ada kesalahan atau tidak valid. Mohon cek kembali input pada form.");

                } else {
                    // toastr.error(data.responseJSON.message);
                    toastr.error(data.responseJSON.message);
                }
                if (data.responseJSON.errors) {
                    var errors = data.responseJSON.errors;
                    var $inputs = [];
                    $.each(errors, function (object, value) {
                        if (object == 'message') {
                            toastr.error(value);
                        }
                        else {
                            let inputNameFormatted;
                            // Check if inputName has dot notation, indicating it's an array input
                            if (object.includes('.')) {
                                var pieces = object.split('.');
                                var firstPiece = pieces.shift();
                                inputNameFormatted = firstPiece + '[' + pieces.join('][') + ']';
                            } else {
                                // If it's not an array input, no need for conversion
                                inputNameFormatted = object;
                            }

                            var $errInputs = $('[name="' + inputNameFormatted + '"]');
                            // Trigger remove first
                            $errInputs.trigger('change.removeInvalid');
                            $errInputs.trigger('keyup.removeInvalid');
                            $errInputs.trigger('select2:open.removeInvalid');
                            for (let i = 0; i < $errInputs.length; i++) {
                                let $errInput = $($errInputs[i]);
                                let isModal = (($errInput.closest('.modal') && $errInput.closest('.modal').length > 0) ? true : false); // modal checking
                                if(isModal) {
                                    // Modal only targeting on modal container, not template
                                    $errInput = $('[name="' + inputNameFormatted + '"]', modalContainerEl);
                                } else {
                                    // Not modal, editing on content only
                                    $errInput = $('[name="' + inputNameFormatted + '"]', '#kt_wrapper');
                                }

                                if ($errInput) {
                                    $inputs.push($errInput);
                                }
                                $errInput.addClass("is-invalid");
                                var $thisFormGroup = $errInput.closest('.form-group, .fv-row');
                                if (value.isArray) {
                                    // thisFormGroup.append('<span class="invalid-feedback" role="alert"><strong>' + value[0] + '</strong></span>');
                                    // errorMessage(thisFormGroup, value[0]);
                                    $thisFormGroup.append('<div class="fv-plugins-message-container invalid-feedback">' + value[0] + '</div>')
                                    if (inputNameFormatted == 'username' || inputNameFormatted == 'email') {
                                        // username, email, and identity showup in one field
                                        // errorMessage($('#f_identity').closest('.form-group'), value[0]);
                                        // $thisFormGroup.append('<div class="fv-plugins-message-container invalid-feedback">' + value[0] + '</div>')
                                    }
                                }
                                else {
                                    // thisFormGroup.append('<span class="invalid-feedback" role="alert"><strong>' + value[0] + '</strong></span>');
                                    // errorMessage(thisFormGroup, value);
                                    $thisFormGroup.append('<div class="fv-plugins-message-container invalid-feedback">' + value + '</div>')
                                    if (inputNameFormatted == 'username' || inputNameFormatted == 'email') {
                                        // // username, email, and identity showup in one field
                                        // errorMessage($('#f_identity').closest('.form-group'), value[0]);
                                    }
                                }

                                // // Removing error
                                // // $errInput.off('keyup.removeInvalid');
                                // $errInput.on('keyup.removeInvalid', function(e){
                                //     let $this = $(e.currentTarget);
                                //     let $invalidResponse = $this.closest('.form-group, .fv-row').find('.fv-plugins-message-container.invalid-feedback');
                                //     // Check if there is an error message
                                //     $invalidResponse.fadeOut(300, null, function () {
                                //         $invalidResponse.remove();
                                //     })
                                //     if ($this.hasClass('is-invalid')) {
                                //         $this.removeClass('is-invalid');
                                //     } else {
                                //         // No error message, then remove the triggering
                                //         $this.off('keyup.removeInvalid');
                                //     }
                                // })

                                // Activating trigger remove form control error
                                $.App.triggerRemoveFormControlError();
                            }
                        }
                    });
                    // if ($inputs && $inputs.length > 0) {
                    //     let errorElementHeightAvg = 0;
                    //     for (let j = 0; j < $inputs.length; j++) {
                    //         errorElementHeightAvg += $inputs[j].offset().top;
                    //     }
                    //     errorElementHeightAvg = errorElementHeightAvg / $inputs.length;
                    //     if (errorElementHeightAvg > 1) {
                    //         $('html,body').animate({ scrollTop: errorElementHeightAvg - (window.screen.height / 4) }, 350, 'linear');
                    //     }
                    // }
                    // $('html,body').animate({ scrollTop: $('.form-group .alert:first').offset().top - window.screen.height / 2 }, 1000, 'easeInOutExpo');
                }
            } else {
                if (data.statusText == 'timeout') {
                    // toastr.error("Unable to contact to the server. Please check your internet connection and make sure it\'s active.");
                }
            }
        } else {
            // There is no data error to be received.
            // toastr.error("Unable to contact to the server. Please check your internet connection and make sure it\'s active.");
        }

    },


    /**
     * Warning Escape Form
     */
    App.prototype.warningEscapeForm = () => {
        $('.form-control').on('keyup', function () {
            $(window).on('beforeunload', function () {
                return 'Are you sure you want to quit this form? Your unsaved data might be loss!';
            });
        });
    },


    /**
     * Enable Warning Escape
     */
    App.prototype.enableWarningEscapeForm = () => {
        $(window).on('beforeunload', function () {
            return 'Are you sure you want to quit this form? Your unsaved data might be loss!';
        });
    },


    /**
     * Disable Warning Escape
     */
    App.prototype.disableWarningEscapeForm = () => {
        $(window).on('beforeunload', () => {return null;});
        $(window).unbind('beforeunload');
    },



    /**
     * Enable safe submit will trigger enable warning escape form
     * if there is change input
     * 
     * @param {*} is_modal 
     */
    App.prototype.enableSafeSubmit = (is_modal = false) => {
        var minInputCount = 2;
        var $container = $('.content');
        var $btnSubmit = $container.find('button[type="submit"], .content #btn_submit.btn');
        var $inputers = $container.find('input:not([type="hidden"]), select:not([type="hidden"]), textarea:not([type="hidden"])');
        if (is_modal) {
            minInputCount = 1;
            $container = $('.modal-container .modal');
            $btnSubmit = $container.find('.modal-footer button[type="submit"]');
            $inputers = $container.find('input:not([type="hidden"]), select:not([type="hidden"]), textarea:not([type="hidden"])');
        }

        // Set off latest safesubmit
        $inputers.off('keyup.safeSubmit change.safeSubmit change.safeSubmit click.safeSubmit');

        var tempvar = {}; // used to store default data. if changes then button willbe remove its disabled state.
        var comparervar = {}; // used to compare change for new updated value
        const isEqual = (a, b) => { // compare object recursive algorithm
            if (a === b) return true;
            if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
            if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
            if (a === null || a === undefined || b === null || b === undefined) return false;
            if (a.prototype !== b.prototype) return false;
            let keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(k => isEqual(a[k], b[k]));
        };
        if ($inputers.length > minInputCount) { // minimal of 3 input (indicates that it is add / edit / delete form)
            $btnSubmit.addClass("disabled");
            $.each($inputers, function (i, dom) {
                var name = $(dom).attr('name');
                var value = $(dom).val();
                // checkbox
                if ($(dom).attr('type') == 'checkbox') {
                    if ($(dom).is(':checked')) {
                        value = $(dom).val();
                    } else {
                        value = "";
                    }
                }

                if (name) { // only name available (ready to send ajax) are stored.
                    tempvar[name] = value;
                }
            });

            $inputers.on('keyup.safeSubmit change.safeSubmit change.safeSubmit click.safeSubmit', function () {
                var change = 0;
                comparervar = {};
                $.each($inputers, function (i, dom) {
                    var name = $(dom).attr('name');
                    var value = $(dom).val();
                    // checkbox
                    if ($(dom).attr('type') == 'checkbox') {
                        if ($(dom).is(':checked')) {
                            value = $(dom).val();
                        } else {
                            value = "";
                        }
                    }

                    if (name) { // only name available (ready to send ajax) are stored.
                        comparervar[name] = value;
                    }
                    // console.log(tempvar, comparervar);
                });
                if (isEqual(tempvar, comparervar)) {
                    change = 0;
                } else {
                    change = 1;
                }
                if (change == 1) {
                    $.App.enableWarningEscapeForm();
                    if ($btnSubmit.hasClass("disabled")) {
                        $btnSubmit.removeClass("disabled");
                    }
                } else {
                    $.App.disableWarningEscapeForm();
                    if (!$btnSubmit.hasClass("disabled")) {
                        $btnSubmit.addClass("disabled");
                    }
                }

            })
        }
    }



    /**
     * Enable safe submit will trigger enable warning escape form
     * if there is change input
     * 
     * @param {*} is_modal 
     */
    /*
    App.prototype.enableSafeSubmit2 = () => {
        var initialInputs = $('input[type!="hidden"]:visible, select.select2:visible, textarea:visible');
        // Store the initial input values
        var initialValues = {};
        initialInputs.each(function () {
            var $this = $(this);
            var name = $this.attr('name');
            if ($this.is('select.select2')) {
                // If the input is a select2 dropdown, get the selected value instead of the input value
                initialValues[name] = $this.select2('data')[0].id;
            } else {
                initialValues[name] = $this.val();
            }
        });
        console.log(initialValues);
        // Listen for changes in the input fields
        initialInputs.on('input change', function () {
            $(window).on('beforeunload', function () {
                // Check if any input value has changed
                for (var i = 0; i < initialInputs.length; i++) {
                    var input = initialInputs.eq(i);
                    var name = input.attr('name');
                    if (input.is('select.select2')) {
                        // If the input is a select2 dropdown, get the selected value instead of the input value
                        if (input.select2('data')[0].id !== initialValues[name]) {
                            return "You have unsaved changes. Are you sure you want to leave this page?";
                        }
                    } else {
                        if (input.val() !== initialValues[name]) {
                            return "You have unsaved changes. Are you sure you want to leave this page?";
                        }
                    }
                }
            });
        });
    },
    */



    /**
     * Privilege Settings
     * 
     * @param {*} allow_edit 
     * @param {*} callback 
     * @returns 
     */
    App.prototype.privilegeSettings = (allow_edit, $customTargets = null, callback = null) => {
        // console.info('>PRIVILEGE SETUP...');
        if (!allow_edit) {
            let $formControls = $('.form-control, .form-select, .form-check-input, [data-repeater-create], [data-repeater-delete]');
            $('.card_action').hide();
            if ($formControls && $formControls.length > 0) {
                for (let i = 0; i < $formControls.length; i++) {
                    let $formcontrol = $($formControls[i]); // convert to jquery dom again
                    if (!$formcontrol.prop('disabled') && !$formcontrol.hasClass('disabled')) {
                        $formcontrol.attr('disabled', 'disabled');
                    }
                    // if (!$formcontrol.hasClass('disabled')) {
                    //     $formcontrol.addClass('disabled');
                    // }
                }
            }
        }
        if (callback) {
            callback();
        }
        return allow_edit;
    },


    /**
     * Aliases privilegeSettings(allow_edit, callback)
     * 
     * @param {*} allow_edit 
     * @param {*} callback 
     * @returns 
     */
    App.prototype.privilegeSetting = (allow_edit, customTargets = null, callback = null) => {
        return $.App.privilegeSettings(allow_edit, customTargets, callback);
    },


    /**
     * Formatting value to indonesian currency
     * 
     * @param {*} value 
     * @param {*} isFormating 
     * @returns {string}
     */
    App.prototype.formatRupiah = (value = 0, isFormating = 0) => {
        // 0 without format, 1 front, 2 front and back
        let currencyAmount = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value) + ',-';
        if (isFormating == 1) {
            // 1
            currencyAmount = currencyAmount.substring(0, (currencyAmount.length - 2));
        }
        if (isFormating == 0) {
            // 2
            currencyAmount = currencyAmount.substring(2, (currencyAmount.length - 2));
        }
        return currencyAmount;
    },


    /**
     * Remove format rupiah
     * Normalize as number
     * 
     * @param {*} value 
     * @returns 
     */
    App.prototype.rFormatRupiah = (value) => {
        value = parseInt(value.replace(/\./g, ''), 10);
        // value = parseInt(value.replace(/,/g, ''), 10);
        return value;
    }


    /**
     * Delay in asyncrhonous mode
     * @param {*} ms 
     * @returns 
     */
    App.prototype.delay = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    /**
     * Show modal message
     * 
     * @param {*} $target 
     * @returns 
     */
    App.prototype.showModalForm = (
        $target = null,
        data = null,
        callbackAfter = null
    ) => {

        if(!$target || ($target && $target.length < 1)) {
            console.error('Need to define the target');
            return false;
        }

        // Setting default function if nullified
        let modal_id = null;
        if (!modal_id) {
            let $checkModal = $('.modal');
            let modalId = 1;
            if ($checkModal.length > 0) {
                modalId = (parseInt($checkModal.length) + 1);
            }
            modal_id = 'showModalView_' + modalId;
        }
        let $container = $(modalContainerEl);

        let title = $target.find('.modal-title').html();
        let subtitle = $target.find('.modal-subtitle').html();
        let body = $target.find('.modal-body').html();
        let footer = $target.find('.modal-footer').html();

        let responsiveModalHeight = $(window).height();
        let maxHeightModalContent = parseInt(responsiveModalHeight * 3/4); // init

        let body_html =
        `<div id="${modal_id}" class="modal fade" role="dialog" tabindex="-1" aria-hidden="true" data-loader-watcher="">` +
            '<div class="modal-dialog ">' + 
                '<div class="modal-content">' + 
                    '<div class="modal-header pb-0 border-0 justify-content-end">' + 
                        '<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">' + 
                            '<span class="svg-icon svg-icon-1">' + 
                                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' + 
                                    '<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />' + 
                                    '<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />' + 
                                '</svg>' + 
                            '</span>' + 
                        '</div>' + 
                    '</div>' + 
                    '<div class="modal-body mx-4 pt-0 pb-10">' + 
                        '<div class="text-center mb-3">' + 
                            `<h1 class="mb-3">${title}</h1>` + 
                            ((subtitle && subtitle.length > 0) 
                                ? `<div class="text-muted fw-bold fs-5">${subtitle}</div>` 
                                : ''
                            ) + 
                        '</div>' + 
            `<div class="scroll-y me-n7 pe-1" style="max-height: ${maxHeightModalContent}px !important;">${body}</div>` + 
                    '</div>' + 
                    '<div class="modal-footer pt-0 border-0">' + 
                        footer + 
                    '</div>' + 
                    '<div class="overlay-layer card-rounded bg-dark bg-opacity-5" style="display: none;">' +
                        '<div class="spinner-border text-primary" role="status">' +
                            '<span class="visually-hidden">Sedang Memuat...</span>' +
                        '</div>' +
                    '</div>' + 
                '</div>' + 
            '</div>' + 
        '</div>';

        // Init to close all modal first
        $('.modal').modal('hide');

        // Remove all contents inside modal-prepared-container.
        $container.html(body_html);
      

        // Default for returning value as dom's.data
        let returnData = {
            title: title, 
            // body: body, 
            data: data, 
            modal_id: modal_id, 
            target_container: $container,
            // Callback
            callbackAfter: callbackAfter,
        };

        // Add watcher for this modalform

        return new Promise((resolve, reject) => {
            $container.find($('#' + modal_id))
                // .modal('show')
                .modal({focus: false})
                .modal('show')
                .on('hidden.bs.modal', function () {
                    // $container.html('');
                    // Have it delay to remove the target modal
                    setTimeout(() => {
                        $container.find($('#' + modal_id)).remove();
                    }, 250);
                })
                .on('shown.bs.modal', function (e) {
                    let $modalForm = $(e.currentTarget);


                    // If there is data result, then search for keys and update the value
                    if (data && (data.result || data.results)) {
                        const dataResults = data.result ?? data.results ?? null;
                        if (dataResults) {
                            // Use traditional search for better performance
                            Object.keys(dataResults).map((key, index) => {
                                let value = dataResults[key];
                                let $targetInput = $modalForm.find('.modal-body').find('form').find('[name="' + key + '"]');
                                if ($targetInput && $targetInput.length > 0) {
                                    if (
                                        $targetInput[0].nodeName == 'TEXTAREA' ||
                                        $targetInput[0].nodeName == 'DIV' ||
                                        $targetInput[0].nodeName == 'SPAN' ||
                                        $targetInput[0].nodeName == 'BUTTON'
                                    ) {
                                        $targetInput.html(value);
                                    } else {
                                        $targetInput.val(value);
                                    }
                                }
                            })
                        }
                    }


                    let $form = $modalForm.find('.modal-body').find('form');
                    // Prevent autosubmit
                    $form.on("keypress", function (e) {
                        var code = e.keyCode || e.which;
                        if (code == 13) {
                            // console.log(code);
                            e.preventDefault(); // remove html autosubmit

                            // auto submit change to modal footer's submit
                            let $modalForm_submit = $modalForm.find('.modal-footer').find('[type="submit"]').trigger('click');
                            // if ($modalForm_submit.find('.indicator-progress').is(':hidden')) {
                            //     // Not loading
                            //     $modalForm_submit
                            // } else {
                            //     // Check swal
                            //     let $poppedUpSwal = $('.swal2-container');
                            //     if ($poppedUpSwal && $poppedUpSwal.length > 0) {
                            //         // There is swal
                            //         $poppedUpSwal.find('.swal2-confirm').trigger('click');
                            //     }
                            // }

                            return false;
                        }
                    })
                    

                    // Callback function if existed
                    if (callbackAfter) {
                        if (typeof callbackAfter == 'function') {
                            callbackAfter();
                        } else if (typeof callbackAfter == 'object') {
                            let func = callbackAfter.func;
                            let data = callbackAfter.data;
                            func(data);
                        }
                    }


                    // Loader and watcher
                    const activateModalFormWatcher = () => {
                        const main = () => {
                            let watcherdata = [];
                            const $modalContent = $($modalForm[0]).find('.modal-content');
                            // Due to extending the $modalForm with other function, standard $modalForm may not work. It will be redefined using $($modalForm[0]). Wrapping the normal javascript dom element with $() jQuery dom element.
                            const $modalFormButtons = $($modalForm[0]).find('.modal-footer button');
                            // Getting modalForms > footer >'s each button for process.
                            if ($($modalForm[0]).data('loader-watcher').length > 1) {
                                watcherdata = JSON.parse($($modalForm[0]).data('loader-watcher'));
                            }
                            if (watcherdata && watcherdata.length > 0) {
                                if (!$($modalForm[0]).hasClass("__loading__")) {
                                    $($modalForm[0]).addClass("__loading__");
                                    $($modalForm[0]).find('.modal-header [data-bs-dismiss="modal"]').hide();
                                    // Overlay Loading add
                                    if (!$modalContent.hasClass('overlay')) {
                                        $modalContent.addClass('overlay overlay-block');
                                        $modalContent.find('.overlay-layer').show();
                                    }
                                }
                                if ($modalFormButtons.length > 0) {
                                    for (let i = 0; i < $modalFormButtons.length; i++) {
                                        let $this = $($modalFormButtons[i]);
                                        if (!$this.attr('disabled')) {
                                            $this.prop('disabled', 'disabled');
                                            if($this.hasClass('indicator-progress')) {
                                                const $default = $this.find('indicator-label');
                                                const $progress = $this.find('.indicator-progress');
                                                if (!$progress.is(':hidden')) {
                                                    $default.hide();
                                                    $progress.show();
                                                }
                                            }
                                        }
                                    }
                                }
                                // $.each($($modalForm[0]).find('.modal-footer button'), (i, target) => {
                                //     let $this = $(target);
                                //     if (!$this.attr('disabled')) {
                                //         $this.prop('disabled', 'disabled');
                                //         if($this.hasClass('indicator-progress')) {
                                //             const $default = $this.find('indicator-label');
                                //             const $progress = $this.find('.indicator-progress');
                                //             if (!$progress.is(':hidden')) {
                                //                 $default.hide();
                                //                 $progress.show();
                                //             }
                                //         }
                                //     }
                                // })
                            } else {
                                if ($($modalForm[0]).hasClass("__loading__")) {
                                    $($modalForm[0]).removeClass("__loading__");
                                    $($modalForm[0]).find('.modal-header [data-bs-dismiss="modal"]').show();
                                    // Overlay Loading remove
                                    if ($modalContent.hasClass('overlay')) {
                                        $modalContent.removeClass('overlay overlay-block');
                                        $modalContent.find('.overlay-layer').hide();
                                    }
                                }
                                // $.each($($modalForm[0]).find('.modal-footer button'), (i, target) => {
                                //     let $this = $(target);
                                //     if ($this.attr('disabled')) {
                                //         $this.prop('disabled', false);
                                //         if ($this.hasClass('indicator-progress')) {
                                //             const $default = $this.find('indicator-label');
                                //             const $progress = $this.find('.indicator-progress');
                                //             if ($progress.is(':hidden')) {
                                //                 $default.show();
                                //                 $progress.hide();
                                //             }
                                //         }
                                //     }
                                // })
                                if ($modalFormButtons.length > 0) {
                                    for (let i = 0; i < $modalFormButtons.length; i++) {
                                        let $this = $($modalFormButtons[i]);
                                        if ($this.attr('disabled')) {
                                            $this.prop('disabled', false);
                                            if ($this.hasClass('indicator-progress')) {
                                                const $default = $this.find('indicator-label');
                                                const $progress = $this.find('.indicator-progress');
                                                if ($progress.is(':hidden')) {
                                                    $default.show();
                                                    $progress.hide();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        main();
                        let watcherId = setInterval(() => {
                            main();
                        }, 333);
                        $modalForm.on('hide.bs.modal', () => {
                            clearInterval(watcherId);
                        })
                        return watcherId;
                    }
                    let watcherId = activateModalFormWatcher(); // auto init
                    

                    $.extend($modalForm, {
                        data: returnData,
                        addWatcher: function (loadername) {
                            let watcherdata = [];
                            if ($($modalForm[0]).data('loader-watcher').length > 0) {
                                // There is watcher data, parse first
                                watcherdata = JSON.parse($($modalForm[0]).data('loader-watcher'));
                                if (watcherdata && watcherdata.indexOf(loadername) < 0) {
                                    watcherdata.push(loadername);
                                }
                            } else {
                                // No watcher data
                                watcherdata.push(loadername);
                            }

                            // Set to the data-attribute
                            $($modalForm[0]).data('loader-watcher', JSON.stringify(watcherdata));

                            return $($modalForm[0]).data('loader-watcher');
                        },
                        removeWatcher: function (loadername) {
                            if ($($modalForm[0]).data('loader-watcher').length < 1) {
                                return $($modalForm[0]).data('loader-watcher');
                            }

                            let watcherdata = JSON.parse($($modalForm[0]).data('loader-watcher'));
                            if (watcherdata && watcherdata.indexOf(loadername) > -1) {
                                let ldri = 0;
                                while (ldri < watcherdata.length)
                                    if (watcherdata[ldri] == loadername)
                                        watcherdata.splice(ldri, 1);
                                    else
                                        ldri++;

                                // Set to the data-attribute
                                $($modalForm[0]).data('loader-watcher', JSON.stringify(watcherdata));
                            }

                            return $($modalForm[0]).data('loader-watcher');
                        },
                        loadingWatcherId: watcherId,
                    });               
                    resolve($modalForm);
                });
        });
    },



    App.prototype.showModal = (
        title = 'Modal', // title*
        subtitle = '', // subtitle
        body = '', // body*
        callback = null, // callback
        modal_id = null, // modal_id
        target_container_class = '.modal-container' // target_container_class
    ) => {

        // Setting default function if nullified
        if (!modal_id) {
            let $checkModal = $('.modal');
            let modalId = 1;
            if ($checkModal.length > 0) {
                modalId = (parseInt($checkModal.length) + 1);
            }
            modal_id = 'showModalView_' + modalId;
        }
        let $container = $(target_container_class);

        let body_html =
            `<div id="${modal_id}" class="modal fade" role="dialog" tabindex="-1" aria-hidden="true">` +
                '<div class="modal-dialog mw-650">' +
                    '<div class="modal-content">' +
                        '<div class="modal-header pb-0 border-0 justify-content-end">' +
                            '<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">' +
                                '<span class="svg-icon svg-icon-1">' +
                                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
                                    '<rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />' +
                                    '<rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />' +
                                    '</svg>' +
                                '</span>' +
                            '</div>' +
                        '</div>' +
                        '<div class="modal-body mx-4 pt-0 pb-10">' +
                            '<div class="text-center mb-13">' +
                                `<h1 class="mb-3">${title}</h1>` +
                                    `<div class="text-muted fw-bold fs-5">${subtitle}</div>` +
                                    '</div>' +
                                '<div class="mb-5">' +
                            `<div class="mh-375px scroll-y me-n7 pe-1">${body}</div>` +
                        '</div>' +
                    '</div>' +
                    '<div class="modal-footer pt-0 border-0">' +
                        '<button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Close</button>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>';

        // Init to close all modal first
        $('.modal').modal('hide');

        // Remove all contents inside modal-prepared-container.
        $container.html(body_html);


        let returnData = {
            title: title,
            body: body,
            callback: callback,
            modal_id: modal_id,
            target_container: $container
        };

        return new Promise((resolve, reject) => {
            $container.find($('#' + modal_id))
                .modal('show')
                .on('hidden.bs.modal', function () {
                    // $container.html('');
                    // Have it delay to remove the target modal
                    setTimeout(() => {
                        $container.find($('#' + modal_id)).remove();
                    }, 250);
                })
                .on('shown.bs.modal', function (e) {
                    // enableSafeSubmit(true);
                    let resolvePromise = $(e.currentTarget);
                    resolvePromise.data = returnData; // add another data

                    // Callback function if existed
                    if (callback) {
                        if (typeof callback == 'function') {
                            callback();
                        } else if (typeof callback == 'object') {
                            let func = callback.callback;
                            let data = callback.data;
                            func(data);
                        }
                    }

                    resolve(resolvePromise);
                });
        });
    },


    /**
     * Swall confirmation
     * @param {*} callback 
     * @param {*} errorAction 
     */
    App.prototype.swalConfirmation = (text = null, callback = null, errorAction = null, errorBackdrop = null) => 
    {
        // let hiddenForms = ['eid', '_eid', 'token', '_token', 'id', '_id']; // key that keeps hidden from showing form
        // if (formData && formData.length > 0) {
        //     // Header
        //     formDataTxt = '<table style="width: 100%; vertical-align: middle; border:none">';
        //     for(let i = 0; i < formData.length; i++) {
        //         key = formData[i].name;
        //         value = formData[i].value;
        //         if(key) {
        //             // Remove hidden key
        //             if (hiddenForms.includes(key)) {
        //                 continue;
        //             }
        //             formDataTxt += '<tr>';
        //             console.log(key, value);
        //             formDataTxt += `<td style="width: 37%">${key}</td>`;
        //             formDataTxt += `<td style="width: 3%">:</td>`;
        //             formDataTxt += `<td style="width: 60%">${value}</td>`;
        //             formDataTxt += '</tr>';
        //         }
        //     }

        //     // Footer
        //     formDataTxt += '</table>';
        // }
        let responsiveWidth = $(window).width();
        let swalWidth = null;
        if (responsiveWidth > 991) {
            // lg
            swalWidth = 0.45 * responsiveWidth;
        } else if (responsiveWidth > 768) {
            // md
            swalWidth = 0.65 * responsiveWidth;
        } else if (responsiveWidth > 575) {
            // sm
            swalWidth = 0.75 * responsiveWidth;
        } else if (responsiveWidth > 400) {
            // xs
            swalWidth = 0.86 * responsiveWidth;
        } else {
            // xxs
            swalWidth = 0.95 * responsiveWidth;
        }
        Swal.fire({
            html: ((text && text.length > 0) ? text : 'Konfirmasi?'),
            icon: "warning",
            width: swalWidth,
            buttonsStyling: false,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "OK!",
            cancelButtonText: "Batal",
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-light"
            }
        }).then(function (result) {
            if (result.value) {

                // Running main function
                if(callback) {
                    callback();
                }

            } else {
                // Cancelled
                if(result.dismiss == 'cancel') {
                    // Cancel button
                    if (errorAction) {
                        errorAction();
                    }
                } else if (result.dismiss == 'backdrop') {
                    // Cancel by backdrop
                    if (errorBackdrop) {
                        errorBackdrop();
                    }
                }
            }
        });
    },


    /**
     * 
     * @param {e, url, formData, swalConfirmationMessage, callbackLoading, callbackSuccess, callbackError, callbackErrorT} object
     * @on action:success
     * @on action:error
     * @on action:errorTotal
     * @returns 
     */
    App.prototype.buttonAction = async (object) => {
        let e = ((object.e) ? object.e : null);
        let url = ((object.url && object.url.length > 0) ? object.url : null);
        let formData = ((object.formData) ? object.formData : null);
        let swal = ((object.swal && object.swal.length > 0) ? object.swal : null);
        let callbackLoading = ((object.callbackLoading) ? object.callbackLoading : null);
        let callbackSuccess = ((object.callbackSuccess) ? object.callbackSuccess : null);
        let callbackError = ((object.callbackError) ? object.callbackError : null);
        let callbackErrorT = ((object.callbackErrorT) ? object.callbackErrorT : null);
        return new Promise((resolve, reject) => {
            $.App._buttonAction(
                e, 
                url, 
                formData, 
                swal,
                callbackLoading,
                callbackSuccess,
                callbackError,
                callbackErrorT
            ).then(result => {
                resolve(result);
            });
        })
    },



    /**
     * 
     * @param {*} e 
     * @param {*} url 
     * @param {*} formData 
     * @param {*} swalConfirmationMessage 
     * @param {*} callbackLoading 
     * @param {*} callbackSuccessResult 
     * @param {*} callbackErrorResult 
     * @param {*} callbackErrorTotal 
     * @on action:success
     * @on action:error
     * @on action:errorTotal
     * @returns 
     */
    App.prototype._buttonAction = async (
        e = null, 
        url = null, 
        formData = null, 
        swalConfirmationMessage = null, 
        callbackLoading = null,
        callbackSuccessResult = null, 
        callbackErrorResult = null, 
        callbackErrorTotal = null
    ) => {
        if(!e) {
            console.error('Target button is not defined');
            return ;
        }
        e.preventDefault();
        const $this = $(e.currentTarget);
        if(!$this || ($this && $this.length < 1)) {
            console.error('Target button cannot be defined');
            return ;
        }
        // // NOT USING URL NOW CAN USE CUSTOM SCRIPT OR MOCKUP
        // if(!url || (url && url.length < 3)) {
        //     console.error("Url must be defined");
        // }

        let $default = $this.find('.indicator-label');
        let $loading = $this.find('.indicator-progress');
        let $success = $this.find('.indicator-success');
        if (!$success.is(':hidden')) {
            $success.hide();
        }


        // This method detect if the button action is in modal.
        // If found, then make the modal unable to dismissable or able to dismissed
        // 0 = cannot be dismissed | 1: can be dismissed
        const buttonActionInModalEffect = (type = 1) => {
            if ($this.closest('.modal') && $this.closest('.modal').length > 0) {
                let $modal = $this.closest('.modal');
                let modalInstance = bootstrap.Modal.getInstance($($modal));
                switch (type) {
                    case 1:
                        $modal.find('[data-bs-dismiss="modal"]')
                            .show();
                        // Update ability regain dismiss
                        modalInstance._config.backdrop = true;
                        modalInstance._config.keyboard = true;
                    break;
                    default:
                        // hide the button 
                        $modal.find('[data-bs-dismiss="modal"]')
                            .hide();
                        // Update can't dismiss
                        modalInstance._config.backdrop = 'static';
                        modalInstance._config.keyboard = false;
                }                
            }
        }
        const loadingAction = async () => {
            $.App.enableWarningEscapeForm();
            $default.hide();
            $loading.show();

            // Modal effect loading
            buttonActionInModalEffect(0);
            

            if (callbackLoading && typeof callbackLoading == 'function') {
                return new Promise(async (resolve, reject) => {
                    resolve(await callbackLoading(formData));
                })
            } else {
                return true;
            }
        }
        const successAction = () => {
            $.App.disableWarningEscapeForm();
            if (!$loading.is(':hidden')) {
                $loading.hide();
            }
            
            // Modal effect ok
            buttonActionInModalEffect(1);


            if($success && $success.length > 0) {
                $success.show();

                setTimeout(() => {
                    $success.hide();
                    $default.show();
                }, 1500)
            } else {

                $default.show();

            }
        }
        const errorAction = () => {
            $.App.disableWarningEscapeForm();
            if (!$loading.is(':hidden')) {
                $loading.hide();
            }

            // Modal effect ok
            buttonActionInModalEffect(1);


            $default.show();
        }
        const mainFunction = async () => {
            if(url && url.length > 1) {
                return new Promise((resolve, reject) => {
                    return $.ajax({
                        data: formData,
                        url: url,
                        success: async function (data) {
                            if (data.status == 'success') {
                                // 200 dan status=success

                                if (data.message && data.message.length > 3) {
                                    toastr.success(data.message);
                                }
                                successAction();

                                if (callbackSuccessResult && typeof callbackSuccessResult == 'function') {
                                    callbackSuccessResult();
                                }
                                $this.trigger('action:success', (e, data));
                                $this.off('action:success');

                            } else {

                                let errMsg = 'Terjadi kesalahan!';
                                // Choosing between error (singular object name) or errors (plural object name)
                                if (data.error) {
                                    errMsg = ((data.error.message) ? data.error.message : null);
                                }
                                if (data.errors) {
                                    errMsg = ((data.errors.message) ? data.errors.message : null);
                                }
                                if (data.message) {
                                    errMsg = ((data.message) ? data.message : null);
                                }
                                if (errMsg.length > 3) {
                                    toastr.warning(errMsg);
                                }
                                errorAction();

                                if (callbackErrorResult && typeof callbackErrorResult == 'function') {
                                    callbackErrorResult();
                                }
                                $this.trigger('action:error', (e, data));
                                $this.off('action:error');
                            }

                            resolve(data);
                        },
                        error: function (data) {
                            // >400 code, biasanya 422 atau kadang 401, 402, 403
                            // errorAction();
                            $.App.errorHandling(data);
                            errorAction();
                            if (callbackErrorTotal && typeof callbackErrorTotal == 'function') {
                                callbackErrorTotal();
                            }
                            $this.trigger('action:errorTotal', (e, data));
                            $this.trigger('action:errorT', (e, data));
                            $this.off('action:errorTotal');
                            $this.off('action:errorT');

                            resolve(data.responseJSON);
                        }
                    });
                });
            } else {

                // SUCCESS ONLY 
                if (callbackSuccessResult && typeof callbackSuccessResult == 'function') {
                    callbackSuccessResult();
                }
                $this.trigger('action:success', (e, null));
                $this.off('action:success');
            }
            
        }


        return new Promise(async (resolve, reject) => {
            // The action
            if (!$this.hasClass('disabled') && !$default.is(':hidden')) {

                let loadResult = await loadingAction();
                await $this.triggerHandler('action:loading', (e));
                if (!loadResult) {
                    errorAction();
                    resolve({
                        0: $this,
                        target: $this,
                        result: null
                    });
                    return ;
                }


                if (swalConfirmationMessage) {
                    Swal.fire({
                        html: swalConfirmationMessage,
                        icon: "warning",
                        width: ((swalConfirmationMessage.length > 100) ? $.Variables.swalWidth() : null),
                        buttonsStyling: false,
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: "OK!",
                        cancelButtonText: "Batal",
                        customClass: {
                            confirmButton: "btn btn-success",
                            cancelButton: "btn btn-light"
                        },
                        keydownListenerCapture: true,
                    }).then(function (result) {
                        if (result.value) {
                            // OK
                            // Running main function
                            mainFunction().then(mainFuncResult => {
                                if($this && $this.length > 0) {
                                    // $this.result = mainFuncResult;
                                    $.extend($this, {
                                        result: mainFuncResult
                                    })
                                }
                                resolve($this);
                            });
                            

                        } else if (result.dismiss == 'cancel') {
                            // Cancelled
                            errorAction();
                            $this.trigger('action:cancel', (e, null));
                            $this.off('action:cancel');
                            if ($this && $this.length > 0) {
                                // $this.result = null;
                                $.extend($this, {
                                    result: null
                                })
                            }
                            resolve($this);
                        } else {
                            // Backdrop
                            errorAction();
                            // Trigger cancelled action from confirmation
                            $this.trigger('action:cancel', (e, null));
                            $this.off('action:cancel');
                            if ($this && $this.length > 0) {
                                // $this.result = null;
                                $.extend($this, {
                                    result: null
                                })
                            }
                            resolve($this);
                        }
                    });
                } else {
                    // Without swal confirmation
                    mainFunction().then(mainFuncResult => {
                        if ($this && $this.length > 0) {
                            // $this.result = mainFuncResult;
                            $.extend($this, {
                                result: mainFuncResult
                            })
                        }
                        resolve($this);
                    });
                }
            }
        });
    },



    /**
     * Used as cached in App State 2
     */
    App.prototype.checkStateCache = {};

    App.prototype.applyStateToButton = function(data, $button) {
        let $this = $button;
        if (!$this || $this.length < 1) {
            return;
        }

        if (data.results) {
            let r = data.results;

            // Hidden
            if (typeof r.hidden != 'undefined') {
                if (r.hidden) {
                    // Set hidden if showed
                    if (!$this.hasClass('hidden-check-state')) {
                        $this.addClass('hidden-check-state');
                    }
                } else {
                    // Set showing if hidden
                    if ($this.hasClass('hidden-check-state')) {
                        $this.removeClass('hidden-check-state');
                    }
                }
            }

            // Disabled
            if (typeof r.disabled != 'undefined') {
                $this.prop('disabled', r.disabled);
            }

            // Text
            if (typeof r.label != 'undefined' && r.label && r.label.length > 0) {
                // Check using indicator label
                if ($this.find('.indicator-label').length > 0) {
                    $this.find('.indicator-label').html(r.label)
                } else {
                    $this.html(r.label)
                }

            }

            // tooltip
            if (typeof r.tooltip != 'undefined' &&
                (r.tooltip && r.tooltip.length > 0)
            ) {
                // Check for tooltip parent
                const $parent = $this.parent();
                if ($parent && $parent.length > 0 && $parent.data('toggle') == 'tooltip') {
                    $parent.tooltip('dispose'); // dispose first then update
                    $parent.tooltip({
                        'title': r.tooltip
                    });
                } else {
                    // Tooltip use this element directly as tooltip
                    $this.tooltip('dispose'); // dispose first then update
                    $this.tooltip({
                        'title': r.tooltip
                    });
                }

            }



            // ClassColor
            if (typeof r.classColor != 'undefined' &&
                (r.classColor && r.classColor.length > 0)
            ) {
                // Remove all coloring first
                $this.removeClass('btn-primary btn-secondary btn-warning btn-info btn-danger btn-success btn-light-primary btn-light-secondary btn-light-warning btn-light-info btn-light-danger btn-light-success');
                // Then add class
                $this.addClass(r.classColor);
            }


            // Foreach data
            if (typeof r.data != 'undefined' &&
                (r.data)
            ) {
                Object.keys(r.data).forEach(key => {
                    // $this.prop('data-' + key, r.data[key]);
                    $this.data(key, r.data[key]);

                })
            }



            // foreach JSON
            if (typeof r.json != 'undefined' && r.json) {
                $this.data('json', (r.json));
            }

        }
    };

    /**
     * Set Check State for button or element
     * Using App state 2
     * 
     * @param {*} $btn 
     * @param {*} url 
     * @returns 
     */
    App.prototype.buttonActionCheckState = ($btn = null, url = null) => {
        /* App state 1
            return new Promise((resolve, reject) => {

            
                if(!$btn || $btn.length < 1 || !url) {
                    return ;
                }

                // Getting $eid
                const $eid = $('.content').find('#f_eid');
                if (!$eid || $eid.length < 1) {
                    console.error('Provide EID, Cannot check state');
                    return ;
                }

                const $this = $btn;
                const lastSegment = url.split('/').pop();
                $this.attr('CHECKSTATE', lastSegment);

                let formData = {
                    '_token': $('[name="_token"]').val(),
                    'eid': $eid.val(),
                }
                const mainFunction = () => {
                    return $.ajax({
                        data: formData,
                        url: url,
                        success: function (data) {
                            if (data.status == 'success') {
                                // 200 dan status=success

                                if (data.results) {
                                    let r = data.results;

                                    // Hidden
                                    if (typeof r.hidden != 'undefined') {
                                        if (r.hidden) {
                                            // Set hidden if showed
                                            if (!$this.hasClass('hidden-check-state')) {
                                                $this.addClass('hidden-check-state');
                                            }
                                        } else {
                                            // Set showing if hidden
                                            if ($this.hasClass('hidden-check-state')) {
                                                $this.removeClass('hidden-check-state');
                                            }
                                        }
                                    }

                                    // Disabled
                                    if (typeof r.disabled != 'undefined') {
                                        $this.prop('disabled', r.disabled);
                                    }

                                    // Text
                                    if (typeof r.label != 'undefined' && r.label && r.label.length > 0) {
                                        // Check using indicator label
                                        if ($this.find('.indicator-label').length > 0) {
                                            $this.find('.indicator-label').html(r.label)
                                        } else {
                                            $this.html(r.label)
                                        }

                                    }

                                    // tooltip
                                    if (typeof r.tooltip != 'undefined' &&
                                        (r.tooltip && r.tooltip.length > 0)
                                    ) {
                                        $this.tooltip('dispose'); // dispose first then update
                                        $this.tooltip({
                                            'title': r.tooltip
                                        });
                                    }



                                    // ClassColor
                                    if (typeof r.classColor != 'undefined' &&
                                        (r.classColor && r.classColor.length > 0)
                                    ) {
                                        // Remove all coloring first
                                        $this.removeClass('btn-primary btn-secondary btn-warning btn-info btn-danger btn-success btn-light-primary btn-light-secondary btn-light-warning btn-light-info btn-light-danger btn-light-success');
                                        // Then add class
                                        $this.addClass(r.classColor);
                                    }


                                    // Foreach data
                                    if (typeof r.data != 'undefined' &&
                                        (r.data && r.data.length > 0)
                                    ) {
                                        Object.keys(r.data).forEach(key => {
                                            $this.prop('data-' + key, r.data[key]);
                                        })

                                    }

                                }

                            }
                            resolve(data)
                        },
                        error: function (data) {
                            // >400 code, biasanya 422 atau kadang 401, 402, 403
                            // App.errorHandling(data);
                            console.error('Check State Error', data);
                            reject({
                                status: 'error',
                                data,
                            });
                        }
                    });
                }

                // Add triggering effect
                $this.on('update updateState', function (e) {
                    e.preventDefault();
                    mainFunction().then(resolve).catch(reject);
                })

                // Call initialize
                mainFunction().then(resolve).catch(reject);
            });*/

        // App State 2
        return new Promise((resolve, reject) => {
            if (!$btn || $btn.length < 1 || !url) {
                reject('Button or URL is not defined');
                return;
            }

            // Getting $eid
            const $eid = $('.content').find('#f_eid');
            if (!$eid || $eid.length < 1) {
                console.error('Provide EID, Cannot check state');
                reject('EID not provided');
                return;
            }

            const $this = $btn;
            const lastSegment = url.split('/').pop();
            $this.attr('CHECKSTATE', lastSegment);

            let formData = {
                '_token': $('[name="_token"]').val(),
                'eid': $eid.val(),
            };

            // Check if the AJAX call for this segment is already made
            if ($.App.checkStateCache[lastSegment]) {
                applyStateToButton($.App.checkStateCache[lastSegment], $this);
                resolve();
                return;
            }

            const mainFunction = () => {
                return $.ajax({
                    data: formData,
                    url: url,
                    success: function (data) {
                        if (data.status == 'success') {
                            // 200 dan status=success

                            // applyStateToButton(data, $this)

                        }
                        resolve(data)
                    },
                    error: function (data) {
                        // >400 code, biasanya 422 atau kadang 401, 402, 403
                        // App.errorHandling(data);
                        console.error('Check State Error', data);
                        reject({
                            status: 'error',
                            data,
                        });
                    }
                });
            };

            // Call AJAX and store the result in the shared cache
            mainFunction().then(data => {
                $.App.checkStateCache[lastSegment] = data; // Store the result
                applyStateToButton(data, $this);
                resolve(data);
            }).catch(error => {
                console.error('Check State Error', error);
                reject({
                    status: 'error',
                    data: error,
                });
            });

            // Add triggering effect
            $this.off('updateState.main');
            $this.on('updateState.main', function (e) {
                e.preventDefault();
                if ($.App.checkStateCache[lastSegment]) {
                    applyStateToButton($.App.checkStateCache[lastSegment], $this);
                    resolve();
                } else {
                    // mainFunction().then(resolve).catch(reject);
                    mainFunction().then(data => {
                        $.App.checkStateCache[lastSegment] = data; // Store the result
                        applyStateToButton(data, $this);
                        resolve(data);
                    }).catch(error => {
                        console.error('Check State Error', error);
                        reject({
                            status: 'error',
                            data: error,
                        });
                    });
                }
            });

            // Define a function to apply the state to a button
            function applyStateToButton(data, $button) {
                let $this = $button;
                if(!$this || $this.length < 1) {
                    return ;
                }
                
                if (data.results) {
                    let r = data.results;

                    // Hidden
                    if (typeof r.hidden != 'undefined') {
                        if (r.hidden) {
                            // Set hidden if showed
                            if (!$this.hasClass('hidden-check-state')) {
                                $this.addClass('hidden-check-state');
                            }
                        } else {
                            // Set showing if hidden
                            if ($this.hasClass('hidden-check-state')) {
                                $this.removeClass('hidden-check-state');
                            }
                        }
                    }

                    // Disabled
                    if (typeof r.disabled != 'undefined') {
                        $this.prop('disabled', r.disabled);
                    }

                    // Text
                    if (typeof r.label != 'undefined' && r.label && r.label.length > 0) {
                        // Check using indicator label
                        if ($this.find('.indicator-label').length > 0) {
                            $this.find('.indicator-label').html(r.label)
                        } else {
                            $this.html(r.label)
                        }

                    }

                    // tooltip
                    if (typeof r.tooltip != 'undefined' &&
                        (r.tooltip && r.tooltip.length > 0)
                    ) {
                        // Check for tooltip parent
                        const $parent = $this.parent();
                        if($parent && $parent.length > 0 && $parent.data('toggle') == 'tooltip') {
                            $parent.tooltip('dispose'); // dispose first then update
                            $parent.tooltip({
                                'title': r.tooltip
                            });
                        } else {
                            // Tooltip use this element directly as tooltip
                            $this.tooltip('dispose'); // dispose first then update
                            $this.tooltip({
                                'title': r.tooltip
                            });
                        }
                        
                    }



                    // ClassColor
                    if (typeof r.classColor != 'undefined' &&
                        (r.classColor && r.classColor.length > 0)
                    ) {
                        // Remove all coloring first
                        let colors = ['primary', 'secondary', 'warning', 'info', 'success', 'danger', 'purple', 'orange'];
                        let btnColorsTxt = '';
                        // Build Txt of colors "btn-primary btn-secondary ..."
                        for (let i = 0; i < colors.length; i++) {
                            let color = colors[i];
                            btnColorsTxt += 'btn-' + color;
                            if(i < (colors.length - 1)) {
                                btnColorsTxt += ' ';
                            }
                        }
                        btnColorsTxt += ' ';
                        // Build Txt of colors "btn-light-primary btn-lightsecondary ..."
                        for (let i = 0; i < colors.length; i++) {
                            let color = colors[i];
                            btnColorsTxt += 'btn-light-' + color;
                            if (i < (colors.length - 1)) {
                                btnColorsTxt += ' ';
                            }
                        }
                        $this.removeClass(btnColorsTxt);
                        // Then add class
                        $this.addClass(r.classColor);
                    }


                    // Foreach data
                    if (typeof r.data != 'undefined' &&
                        (r.data)
                    ) {
                        Object.keys(r.data).forEach(key => {
                            // $this.prop('data-' + key, r.data[key]);
                            $this.data(key, r.data[key]);
                            
                        })
                    }



                    // foreach JSON
                    if(typeof r.json != 'undefined' && r.json) {
                        $this.data('json', (r.json));
                    }

                }
            }
        })
    }
    // Alias ElementCheckState
    App.prototype.elementCheckState = ($btn = null, url = null) => {
        $.App.buttonActionCheckState($btn, url);
    },



    /**
     * Trigger to update State
     */
    App.prototype.buttonActionUpdateState = async ($btns = null) => {
        if (!$btns || $btns.length < 1) {
            $btns = $('[CHECKSTATE]');
        }
        // $btns.trigger('updateState');
        // let $btns = $('[CHECKSTATE]');
        if ($btns && $btns.length > 0) {
            for (let i = 0; i < $btns.length; i++) {
                let $btn = $($btns[i]);

                await $.App.delay(25); // every seconds there is 5 state

                $btn.trigger('updateState');
            }
        }

        setTimeout(() => {
            $.App.checkStateCache = {}; // clear cache checkstate
        }, 100);

        return $btns;
    },
    // Alias
    App.prototype.updateState = async ($btns = null) => {
        await $.App.buttonActionUpdateState($btns);
    },



    /**
     * Activate Tiny Slider (KTApp)
     * @returns 
     */
    App.prototype.initTinySliders = function () {
        // Init Slider
        var initSlider = function (el) {
            if (!el) {
                return;
            }

            const tnsOptions = {};

            // Convert string boolean
            const checkBool = function (val) {
                if (val === 'true') {
                    return true;
                }
                if (val === 'false') {
                    return false;
                }
                return val;
            };

            // get extra options via data attributes
            el.getAttributeNames().forEach(function (attrName) {
                // more options; https://github.com/ganlanyuan/tiny-slider#options
                if ((/^data-tns-.*/g).test(attrName)) {
                    let optionName = attrName.replace('data-tns-', '').toLowerCase().replace(/(?:[\s-])\w/g, function (match) {
                        return match.replace('-', '').toUpperCase();
                    });

                    if (attrName === 'data-tns-responsive') {
                        // fix string with a valid json
                        const jsonStr = el.getAttribute(attrName).replace(/(\w+:)|(\w+ :)/g, function (matched) {
                            return '"' + matched.substring(0, matched.length - 1) + '":';
                        });
                        try {
                            // convert json string to object
                            tnsOptions[optionName] = JSON.parse(jsonStr);
                        }
                        catch (e) {
                        }
                    }
                    else {
                        tnsOptions[optionName] = checkBool(el.getAttribute(attrName));
                    }
                }
            });

            const opt = Object.assign({}, {
                container: el,
                slideBy: 'page',
                autoplay: true,
                autoplayButtonOutput: false,
            }, tnsOptions);

            if (el.closest('.tns')) {
                KTUtil.addClass(el.closest('.tns'), 'tns-initiazlied');
            }

            return tns(opt);
        }

        // Sliders
        const elements = Array.prototype.slice.call(document.querySelectorAll('[data-tns="true"]'), 0);
        // console.log(elements);

        if (!elements && elements.length === 0) {
            return;
        }

        elements.forEach(function (el) {
            initSlider(el);
        });
    },



    /**
     * Popover on device that have touch fix
     * 
     */
    App.prototype.popoverTouchDevice = function () {
        $('*').bind('touchend', function (e) {
            if ($(e.target).attr('rel') !== 'tooltip' && ($('div.tooltip.in').length > 0)) {
                $('[rel=tooltip]').mouseleave();
                e.stopPropagation();
            } else {
                $(e.target).mouseenter();
            }
        });
    },



    /**
     * Convert json string to prettifier with syntax highlight
     * @param {*} json 
     * @returns 
     */
    App.prototype.syntaxHighlightJson = function(json) {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'text-primary'; // number
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'text-danger'; // key
                } else {
                    cls = 'text-success'; // string
                }
            } else if (/true|false/.test(match)) {
                cls = 'text-warning'; // boolean
            } else if (/null/.test(match)) {
                cls = 'text-gray-600'; // nullified
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    },



    /**
     * Get count from object
     * @param {*} object 
     * @returns 
     */
    App.prototype.count = function(object) {
        return Object.keys(object).length;
    },


    /**
     * Check if the input is numeric type
     * 
     * @param {*} n 
     * @returns 
     */
    App.prototype.isNumeric = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },
    
    /**
     * Alias from isNumeric. Can use App.is_numeric
     * 
     * @param {*} n 
     * @returns 
     */
    App.prototype.is_numeric = (n) => {
        return $.App.isNumeric(n);
    },


    /**
     * Check if valid json
     * @param {*} json 
     * @returns 
     */
    App.prototype.is_valid_json = (json) => {
        try {
            JSON.parse(json);
            return true;
        } catch (e) {
            return false;
        }
    },


    /**
     * Aliases from `is_valid_json`
     * @param {*} json 
     * @returns 
     */
    App.prototype.isValidJson = (json) => {
        return $.App.is_valid_json(json);
    },


    /**
     * data-bs-trigger="focus" popover will be list if the user
     *click even in the inside of popover
     * This custom function will cover this issue
     * 
     * @returns 
    */
    App.prototype.customTriggerFocusPopover = () => {
        // Popover advance focus
        $('body, a, .btn').off('click.popoverFocus');
        $('body, a, .btn').on('click.popoverFocus', function (e) {
            let $popovers = $('[data-bs-toggle="popover"]'); // all popovers
            for (let i = 0; i < $popovers.length; i++) {
                let $this = $($popovers[i]);
                //the 'is' for buttons that trigger popups
                //the 'has' for icons within a button that triggers a popup
                if (!$this.is(e.target) && $this.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $this.popover('hide');
                }
            }
        });
    },


    /**
     * Load metric boxes
     * Manually using App.loadMetricBox
     * @returns
     */
    App.prototype.loadMetricBox = async () => {
        let $metrics = $('[data-toggle="metric"]', contextEl);
        var debounceTimeoutId = null;
        clearTimeout(debounceTimeoutId);

        // Prepare loading function
        const loadingAction = ($target) => {
            if (parseInt($target.html()) == 0) {
                $target.html('<span class="spinner-border spinner-border-lg align-middle ms-2"></span>');
            }
        }

        if (!$metrics || $metrics.length < 1) {
            return;
        }

        /**
         * Metric Calculate
         * @param {*} $this 
         */
        const main = async ($this) => {
            if ($this && $this.length > 0) {
                let metricUrl = $this.data('url');
                let $text = $this.find('._count');
                let lastCount = parseInt($text.html());
                // Begin Loading

                loadingAction($text);

                if (!metricUrl || metricUrl.length < 1) {
                    // No URL, based on count
                    if (parseInt($text.html())) {
                        new CountUp(
                            $text[0], // javascript dom element
                            parseInt($text.html()),  // number (in integer)
                            // optional
                            {
                                startVal: 0,
                                duration: $.Variables.countUpDuration,
                                separator: ','
                            }
                        ).start();
                    } else {
                        $text.html(0);
                    }
                    return;
                }

                // Form Data
                let formData = $this.find(':input').serializeArray();
                formData.push({ name: '_token', value: $('[name="_token"]').val() });


                // Custom object keys method
                let filterStartAtFormData = [];
                let filterEndAtFormData = [];
                let filterBranchFormData = [];

                // Begin checking
                let $filterStartAt = $('#f_filter_start_at', contextEl);
                if ($filterStartAt && $filterStartAt.length > 0) {
                    // Wait for filterStartAt value and input
                    await (async ($target) => {
                        let checkCount = 1;
                        const maxCheckCount = 30; // 3 seconds
                        const interval = 50; // every in miliseconds

                        return new Promise((resolve, reject) => {
                            if ($target.val() && $target.val().length > 0) {
                                // Found values
                                filterStartAtFormData.push({ name: 'filter_start_at', value: $target.val() });
                                // clearInterval(checkInterval); // out looping
                                resolve();
                            } else {
                                const checkInterval = setInterval(() => {
                                    if ($target.val() && $target.val().length > 0) {
                                        // Found values
                                        filterStartAtFormData.push({ name: 'filter_start_at', value: $target.val() });
                                        clearInterval(checkInterval); // out looping
                                        resolve();
                                    } else if (checkCount >= maxCheckCount) {
                                        // console.error(`Timeout waiting for ${$target[0].id} to have value`);
                                        clearInterval(checkInterval);
                                        // reject(new Error(`Timeout waiting for ${$target[0].id}`));
                                        resolve();
                                    }
                                    checkCount++;

                                }, interval);
                            }
                        });
                    })($filterStartAt)
                }

                let $filterEndAt = $('#f_filter_end_at', contextEl);
                if ($filterEndAt && $filterEndAt.length > 0) {
                    // Wait for filterEndAt value and input
                    await (async ($target) => {
                        let checkCount = 1;
                        const maxCheckCount = 30; // 3 seconds
                        const interval = 50; // every in miliseconds

                        return new Promise((resolve, reject) => {
                            if ($target.val() && $target.val().length > 0) {
                                // Found values
                                filterEndAtFormData.push({ name: 'filter_end_at', value: $target.val() });
                                // clearInterval(checkInterval); // out looping
                                resolve();
                            } else {
                                const checkInterval = setInterval(() => {

                                    if ($target.val() && $target.val().length > 0) {
                                        // Found values
                                        filterEndAtFormData.push({ name: 'filter_end_at', value: $target.val() });
                                        clearInterval(checkInterval); // out looping
                                        resolve();
                                    } else if (checkCount >= maxCheckCount) {
                                        // console.error(`Timeout waiting for ${$target[0].id} to have value`);
                                        clearInterval(checkInterval);
                                        // reject(new Error(`Timeout waiting for ${$target[0].id}`));
                                        resolve();
                                    }
                                    checkCount++;

                                }, interval);
                            }
                        });
                    })($filterEndAt)
                }

                let $filterBranch = $('#f_filter_branch', contextEl);
                if ($filterBranch && $filterBranch.length > 0) {
                    // alert("METRIC CHECKING BRANCH");
                    // Wait for filterBranch value and input
                    await (async ($target) => {
                        let checkCount = 1;
                        const maxCheckCount = 30; // 3 seconds
                        const interval = 50; // every in miliseconds

                        return new Promise((resolve, reject) => {
                            if ($target.val() && $target.val().length > 0) {
                                // console.log('METRIC $target.val() FOUND...', $target.val());
                                // Found values
                                const values = $target.val();
                                if (Array.isArray(values)) {
                                    values.forEach((value) => {
                                        // formData.push({ name: 'filter_branch[]', value: value });
                                        filterBranchFormData.push({ name: 'filter_branch[]', value: value });
                                    });
                                } else {
                                    // formData.push({ name: 'filter_branch', value: values });
                                    filterBranchFormData.push({ name: 'filter_branch[]', value: value });
                                }
                                // clearInterval(checkInterval); // out looping
                                resolve();
                            } else {
                                const checkInterval = setInterval(() => {
                                    // console.log('METRIC Checking...', (checkCount+1))
                                    if ($target.val() && $target.val().length > 0) {
                                        // console.log('METRIC $target.val() FOUND...', $target.val());
                                        // Found values
                                        const values = $target.val();
                                        if (Array.isArray(values)) {
                                            values.forEach((value) => {
                                                // formData.push({ name: 'filter_branch[]', value: value });
                                                filterBranchFormData.push({ name: 'filter_branch[]', value: value });
                                            });
                                        } else {
                                            // formData.push({ name: 'filter_branch', value: values });
                                            filterBranchFormData.push({ name: 'filter_branch[]', value: value });
                                        }
                                        clearInterval(checkInterval); // out looping
                                        resolve();
                                    } else if (checkCount >= maxCheckCount) {
                                        // console.error(`Timeout waiting for ${$target[0].id} to have value`);
                                        clearInterval(checkInterval);
                                        // reject(new Error(`Timeout waiting for ${$target[0].id}`));
                                        resolve();
                                    }
                                    checkCount++;

                                }, interval);
                            }

                        });
                    })($filterBranch)
                }

                if (filterStartAtFormData && filterStartAtFormData.length > 0) {
                    // Merge 2 arrays
                    formData = [
                        ...formData,
                        ...filterStartAtFormData
                    ];
                }
                if (filterEndAtFormData && filterEndAtFormData.length > 0) {
                    // Merge 2 arrays
                    formData = [
                        ...formData,
                        ...filterEndAtFormData
                    ];
                }
                if (filterBranchFormData && filterBranchFormData.length > 0) {
                    // formData.push(filterBranchFormData);
                    // Merge 2 arrays
                    formData = [
                        ...formData,
                        ...filterBranchFormData
                    ];
                }

                // Other input


                // Ajax Load
                $.ajax({
                    data: formData,
                    url: metricUrl,
                    success: function (data) {
                        if (data.status == 'success' && data.results) {
                            // 200 dan status=success
                            // let lastCount = parseInt($text.html()); // on upper side
                            let count = 0;

                            if (typeof data.results.totalCount != 'undefined') {
                                count = data.results.totalCount;
                            }

                            if (typeof data.results.total_count != 'undefined') {
                                count = data.results.total_count;
                            }


                            $text.html(count);

                            if (count != lastCount) {
                                new CountUp(
                                    $text[0], // javascript dom element
                                    parseInt(count),  // number (in integer)
                                    // optional
                                    {
                                        startVal: lastCount || 0,
                                        duration: $.Variables.countUpDuration,
                                        separator: ','
                                    }
                                ).start();
                            }


                            // if (typeof data.results.totalCount != 'undefined' || typeof data.results.total_count != 'undefined') {

                            // }


                        } else {
                            // 200 error
                            $text.html(0);
                        }
                    },
                    error: function (data) {
                        // >400 code, biasanya 422 atau kadang 401, 402, 403
                        // errorAction();
                        $.App.errorHandling(data);
                    }
                });
            }
        }



        for (let i = 0; i < $metrics.length; i++) {
            main($($metrics[i]));

            // Add trigger 'update' method
            $($metrics[i]).on('update', function () {
                let $this = $(this);
                main($this);
            })
        }
    }


    App.prototype.UIUXloadBranchSelect2List = () => {
        let $branch = $('#f_branch, [data-input="branch"]');
        if (!$branch || ($branch && $branch.length < 1)) {
            return;
        }
        const $this = $branch;
        let formData = {
            '_token': $('[name="_token"]').val(),
            'init': $this.data('init'),
            'allow_all': $this.data('allow-all'),
        };
        let isHtml = false;
        if($this.data('html')) {
            isHtml = true;
        }
        // Remove data init if existed
        $this.removeAttr('data-init'); // only once of init
        return $.ajax({
            data: formData,
            url: URL_LOADBRANCHES_SELECT2LIST, // footer-script
            success: function (data) {
                if (data.status == 'success') {
                    // 200 dan status=success

                    if ($this.data('select2')) {
                        $this.select2('destroy')
                    }

                    $this.html('');

                    if (isHtml) {
                        // Use html method
                        $this.select2({
                            data: data.results,
                            escapeMarkup: function (markup) { return markup; }, // don't escape HTML tags
                            templateResult: function (item) {
                                // If there's no id, it's a placeholder
                                if (!item.id) {
                                    return item.text;
                                }
                                // Return the custom HTML if available, or fallback to text.
                                return item.html ? item.html : item.text;
                            },
                            templateSelection: function (item) {
                                return item.text;
                            }
                        })

                    } else {
                        // No html
                        $this.select2({
                            data: data.results
                        })
                    }
                    $this.trigger('change.select2');

                    // Reload table if has value
                    if ($this.data('init')) {
                        let $tables = $('.table');
                        if ($tables && $tables.length > 0) {
                            for (let i = 0; i < $tables.length; i++) {
                                let $table = $($tables[i]);
                                if ($.fn.DataTable.isDataTable($table)) {
                                    // Check if datatable, if true then reload with delayed 50ms
                                    setTimeout(() => {
                                        const tableAjaxData = $table.DataTable().settings().ajax;
                                        console.log(tableAjaxData.json());
                                        // Check first if ajax provided
                                        if (
                                            tableAjaxData &&
                                            tableAjaxData.url() && tableAjaxData.url().length > 3
                                        ) {
                                            $table.dataTable().api().ajax.reload(null, false);
                                        }
                                    }, 100);
                                }
                            }

                        }
                    }

                    // Hide allowAll
                    if ($this.data('allow-all')) {
                        $this.removeAttr('data-allow-all');
                    }

                    // Hide allowClear
                    if ($this.data('allow-clear')) {
                        $this.removeAttr('data-allow-clear');
                    }

                } else {
                    toastr.warning(data.message);
                }
            },
            error: function (data) {
                // >400 code, biasanya 422 atau kadang 401, 402, 403
                $.App.errorHandling(data);
            }
        });
    },

    /**
     * Activate trigger UIUX effect of city and province
     * [data-input="province"][data-input="city"]
     * Provided targetContainer will make the function easier to locate the data-input="province"
     */
    App.prototype.UIUXCityProvince = ($targetContainer) => {
        // On province change, load city data from (main.loadcities)
        const loadCityFromProvinceSelect2List = ($province, $city) => {
            if (!$city || ($city && $city.length < 1)) {
                return ;
            }
            if (!$province || ($province && $province.length < 1)) {
                return;
            }
            $province.off('change.select2Province');
            $province.on('change.select2Province', function (e) {
                let $this = $(e.currentTarget);
                let initVal = $city.data('init') ?? ($city.val() ?? '0');

                let formData = {
                    '_token': $('[name="_token"]').val(),
                    'province': $this.val(),
                    'init': $city.data('init'),
                };
                // console.log(formData);
                $city.removeAttr('data-init'); // only once of init
                $.ajax({
                    data: formData,
                    url: URL_LOADCITIES_SELECT2LIST, // footer-script
                    success: function (data) {
                        if (data.status == 'success') {
                            // 200 dan status=success
                            if ($city.data('select2')) {
                                $city.select2('destroy')
                            }
                            $city.html('');
                            $city.select2({
                                data: data.results
                            })

                            if (initVal) {
                                $city.val(initVal);
                            }

                            $city.trigger('change.select2');

                        } else {
                            toastr.warning(data.message);
                        }
                    },
                    error: function (data) {
                        // >400 code, biasanya 422 atau kadang 401, 402, 403
                        $.App.errorHandling(data);
                    }
                });
            });
            if ($province.val()) {
                $province.trigger('change.select2Province');
            }
            
        }


        // On province change, load city data from (main.loadProvinces)
        const loadProvinceSelect2List = () => {
            let $provinces = $('#f_province, [data-input="province"]');
            if ($targetContainer) {
                $provinces = $targetContainer.find('#f_province:not([disabled]), [data-input="province"]:not([disabled])');
            }
            
            if (!$provinces || ($provinces && $provinces.length < 1)) {
                return;
            }
            // Remove data init if existed
            for (let i = 0; i < $provinces.length; i++) {
                let $province = $($provinces[i]);
                let $city = $province.closest('.row').find('#f_city, [data-input="city"]'); // city must beside and in this row
                // Default City
                $city.select2({
                    data: [{
                        id: '0',
                        text: 'Tidak ada Kota..',
                        selected: true,
                    }]
                });
                let formData = {
                    '_token': $('[name="_token"]').val(),
                    'init': $province.data('init'),
                };
                $province.removeAttr('data-init'); // only once of init
                $.ajax({
                    data: formData,
                    url: URL_LOADPROVINCES_SELECT2LIST, // footer-script
                    success: function (data) {
                        if (data.status == 'success') {
                            // 200 dan status=success

                            let initVal = $province.val() ?? '0';
                            if ($province.data('select2')) {
                                $province.select2('destroy')
                            }
                            $province.html('');
                            $province.select2({
                                data: data.results
                            });

                            // The results has initVal from data-init-val, but if the element updated again, the latest value will be updated
                            if (initVal) {
                                $province.val(initVal);
                            }

                            $province.trigger('change.select2Province');

                        } else {
                            toastr.warning(data.message);
                        }

                        // Get nearest city to load province
                        loadCityFromProvinceSelect2List($province, $city);
                    },
                    error: function (data) {
                        // >400 code, biasanya 422 atau kadang 401, 402, 403
                        $.App.errorHandling(data);
                    }
                });
            }   
            
            return 
        }
        loadProvinceSelect2List();


        // Location (subdistrict, city, province) autoload
        const loadLocationSelet2List = ($targetContainer) => {
            let $locations = $('.content').find('#f_location:not([disabled]), [data-input="location"]:not([disabled])');
            if ($targetContainer && $targetContainer.length > 0) {
                $locations = $targetContainer.find('#f_province:not([disabled]), [data-input="location"]:not([disabled])');
            }

            if (!$locations || ($locations && $locations.length < 1)) {
                return;
            }
            // Remove data init if existed
            for (let i = 0; i < $locations.length; i++) {
                let $location = $($locations[i]);
                
                if ($location.data('select2')) {
                    $location.select2('destroy')
                }
                
                setTimeout(() => {

                    let locationInitVal = $location.data('init-json');
                    $location.removeAttr('data-init-json');
                    $location.select2({
                        ajax: {
                            delay: 200,
                            type: 'POST',
                            dataType: 'json',
                            url: URL_LOADLOCATION_SELECT2LIST,
                            data: function (params) {
                                var query = {
                                    _token: $('[name="_token"]').val(),
                                    search: params.term,
                                    // init: locationInitVal,
                                    // type: 'public'
                                }
                                // console.log(query);
                                return query;
                            },
                            processResults: function (data, params) {
                                // parse the results into the format expected by Select2
                                // since we are using custom formatting functions we do not need to
                                // alter the remote JSON data, except to indicate that infinite
                                // scrolling can be used
                                // params.page = params.page || 1;

                                return {
                                    results: data.results,
                                    // pagination: {
                                    //     more: (params.page * 30) < data.total_count
                                    // }
                                };
                            },
                            cache: true,
                        },
                        minimumInputLength: 1,
                    });



                    // Trigger change to load ajax if there is initValue
                    let selectedOpts = [];
                    if (locationInitVal) {
                        selectedOpts = new Option(
                            locationInitVal.name, // text
                            locationInitVal.id,  // id
                            false,
                            false
                        );
                    } else {
                        selectedOpts = new Option(
                            'Tidak set kecamata, kota, provinsi...', // text
                            '0',  // id
                            false,
                            false
                        );
                    }
                    // console.log(selectedOpts, locationInitVal);
                    // $location.append(selectedOpts).val(locationInitVal.id).trigger({
                    //     type: 'select2:select',
                    // })
                    $location.append(selectedOpts).val(locationInitVal.id);
                    $location.trigger({
                        type: 'select2:select',
                    })
                    

                }, 200);
            }
            return;
        }
        loadLocationSelet2List($targetContainer);
    },



    /**
     * Image Input Upload
     * Target: .card._imageInput, ._template._imageInputTemplate, .image-input, a[lightbox]
     * Combining KTImageInput, Magnific Popup (dependencies), and custom upload image UIUX
     * 
     * @returns null
     */
    App.prototype.UIUXimageInputUpload = () => {

        const $card = $('.card._imageInput');
        const $cardBody = $card.find('.card-body');
        const $template = $card.find('._imageInputTemplate');
        const $lightboxes = $template.next().find('[lightbox]');
        // console.log('Checking UIUXImageInputUpload', $card, $cardBody, $template, $lightboxes);
        const maxImageInput = $card.data('max-upload') ?? 10;
        let countImageInput = $cardBody.find('.image-input').length;

        const maxWidthForCompress = 1200;
        const maxHeightForCompress = 1200;


        let $imageInputs = null;
        

        // Create Instance KTImageInput
        const createKTImageInputInstance = () => {
            // INIT CREATE NEW INSTANCE FROM TEMPLATE
            if (countImageInput < maxImageInput) {
                $cardBody.append($template.html());
            }
            KTImageInput.init(); // KTImageInput basic function

            $imageInputs = $cardBody.find('.image-input');
            // console.log($imageInputs);
            
            if (!$imageInputs || $imageInputs.length < 1) {
                return;
            }

            return $imageInputs;
        }

        // Checking image (for lightbox)
        const loadImage = (url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;
                img.onload = () => resolve(img);
                img.onerror = reject;
            });
        }


        // Check to load image, if available, lightbox will showing the image group as gallery. If not, they will not be displayed as image and skipped from gallery.
        (async function () {
            for (let i = 0; i < $lightboxes.length; i++) {
                const $lightbox = $($lightboxes[i]);
                try {
                    const img = await loadImage($lightbox.attr('href'));
                    $lightbox.addClass('_ok');
                } catch (error) {
                    console.error(error);
                }
            }

            // Find the card-body of lightboxes that have _ok class which means the target image can be loaded as image.
            $template.next().find('[lightbox]._ok').magnificPopup({
                type: 'image',
                mainClass: 'mfp-with-zoom',
                gallery: {
                    enabled: true
                }
            });
        })();


        // Set progress checking
        const setProgress = (imageInputEl, value) => {
            let $this = $(imageInputEl).find('._progressbar');
            if (!$this || $this.length < 1) {
                return;
            }
            if (value > 0) {
                let $progress = $this.find('[role="progressbar"]');
                // Show progress
                if ($this.is(':hidden')) {
                    $this.show();
                }
                // Set value of progressBar
                $progress
                    .css('width', value.toString() + '%')
                    .prop('aria-valuenow', value);
                if (value < 25) {
                    if (
                        $progress.hasClass('bg-info') ||
                        $progress.hasClass('bg-success') ||
                        $progress.hasClass('bg-danger')
                    ) {
                        $progress.removeClass('bg-info bg-success bg-danger');
                    }
                    $progress.addClass('bg-warning');
                } else if (value >= 25 && value < 70) {
                    if (
                        $progress.hasClass('bg-warning') ||
                        $progress.hasClass('bg-success') ||
                        $progress.hasClass('bg-danger')
                    ) {
                        $progress.removeClass('bg-warning bg-success bg-danger');
                    }
                    $progress.addClass('bg-info');
                } else if (value >= 70 && value < 99) {
                    if (
                        $progress.hasClass('bg-warning') ||
                        $progress.hasClass('bg-info') ||
                        $progress.hasClass('bg-danger')
                    ) {
                        $progress.removeClass('bg-warning bg-info bg-danger');
                    }
                    $progress.addClass('bg-success');
                } else {
                    if (
                        $progress.hasClass('bg-warning') ||
                        $progress.hasClass('bg-info') ||
                        $progress.hasClass('bg-danger')
                    ) {
                        $progress.removeClass('bg-warning bg-info bg-danger');
                    }
                    $progress.addClass('bg-success');
                    // Delay 500 and hide
                    setTimeout(() => {
                        $this.hide();
                    }, 500);
                }
            }
        }

        // Compress Image
        const compressImage = async (imageInputEl, theFile, progressCallback) => {
            if (!imageInputEl) {
                toastr.error('Gambar belum dimuat!');
                return;
            }
            return new Promise((resolve, reject) => {
                // Set background to white for context of canvas
                $.App.overlayLoading(true); // set entire screen is loading

                let canvas = $(imageInputEl).find('._imageCanvas')[0];
                let context = canvas.getContext('2d');
                context.fillStyle = 'white';
                context.fillRect(0, 0, canvas.width, canvas.height);
                var reader = new FileReader();
                reader.onload = function (event) {
                    var img = new Image();
                    img.src = event.target.result;
                    img.onload = function () {
                        var maxWidth = maxWidthForCompress;
                        var maxHeight = maxHeightForCompress;
                        var width = img.width;
                        var height = img.height;

                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width;
                                width = maxWidth;
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height;
                                height = maxHeight;
                            }
                        }



                        canvas.width = width;
                        canvas.height = height;
                        // context.globalCompositeOperation = 'source-over';
                        context.drawImage(img, 0, 0, width, height);
                        canvas.toBlob(function (blob) {
                            // let theFileFullName = theFile.name;
                            // let thisFileName = theFileFullName.substring(0, theFileFullName.lastIndexOf('.'));
                            // let thisFileFormat = theFileFullName.substring(theFileFullName.lastIndexOf('.') + 1).toLowerCase();

                            let newFileName = $.App.generateUUID();
                            $.App.overlayLoading(false); 
                            resolve({
                                filename: newFileName,
                                blob: blob,
                            });
                        })
                    }
                }
                reader.onprogress = function (e) {
                    if (e.lengthComputable) {
                        let progress = (e.loaded / e.total) * 100;
                        progressCallback(progress);
                    }
                }
                let imageInput = KTImageInput.getInstance(imageInputEl);
                reader.readAsDataURL(imageInput.getInputElement().files[0]);
            });
        }

        // Process PDF to Image (Page COVER only)
        const processPdf = async (imageInputEl, theFile, progressCallback) => {
            if (!imageInputEl) {
                toastr.error('Gambar belum dimuat!');
                return;
            }
            return new Promise((resolve, reject) => {
                $.App.overlayLoading(true); // Set entire screen loading
                var reader = new FileReader();
                reader.readAsArrayBuffer(theFile);
                reader.onloadend = function () {
                    var typedarray = new Uint8Array(this.result);
                    pdfjsLib.getDocument(typedarray).promise.then(async function (pdf) {

                        // Process only cover
                        pdf.getPage(1).then(function (page) {
                            var viewport = page.getViewport({ scale: 1 });
                            let canvas = $(imageInputEl).find('._imageCanvas')[0];
                            canvas.width = viewport.width;
                            canvas.height = viewport.height;
                            let context = canvas.getContext('2d');
                            context.fillStyle = 'white';
                            let renderContext = {
                                canvasContext: context,
                                viewport: viewport,
                                onprogress: function (progressData) {
                                    if (progressData.lengthComputable) {
                                        let progress = (progressData.loaded / progressData.total) * 100;
                                        progressCallback(progress);
                                    }
                                }
                            };
                            page.render(renderContext).promise.then(function () {
                                canvas.toBlob(function (blob) {

                                    var icanvas = document.createElement('canvas');
                                    var icontext = icanvas.getContext('2d');
                                    var iimage = new Image();
                                    iimage.src = URL.createObjectURL(blob);
                                    iimage.onload = function () {
                                        // icanvas.width = iimage.width;
                                        // icanvas.height = iimage.height;
                                        icanvas.fillStyle = 'white';
                                        var maxWidth = maxWidthForCompress;
                                        var maxHeight = maxHeightForCompress;
                                        var width = iimage.width;
                                        var height = iimage.height;

                                        if (width > height) {
                                            if (width > maxWidth) {
                                                height *= maxWidth / width;
                                                width = maxWidth;
                                            }
                                        } else {
                                            if (height > maxHeight) {
                                                width *= maxHeight / height;
                                                height = maxHeight;
                                            }
                                        }
                                        // Update the ratio
                                        icanvas.width = width;
                                        icanvas.height = height;
                                        icontext.drawImage(iimage, 0, 0, iimage.width, iimage.height);
                                        icanvas.toBlob(function (blob) {
                                            // Update image-input-wrapper background
                                            $(imageInputEl).find('.image-input-wrapper').css('background-image', 'url(' + icanvas.toDataURL() + ')');
                                            let newFileName = $.App.generateUUID();

                                            $.App.overlayLoading(false); 

                                            resolve({
                                                filename: newFileName,
                                                blob: blob,
                                            });
                                        });
                                    };
                                })
                            })
                        })

                        // Process whole page
                        /*
                        let numPages = pdf.numPages;
                        let pages = [];
                        for (let i = 1; i <= numPages; i++) {
                            const page = await pdf.getPage(i);
                            var viewport = page.getViewport({ scale: 1 });
                            let canvas = $(imageInputEl).find('._imageCanvas')[0];
                            canvas.width = viewport.width;
                            canvas.height = viewport.height;
                            let context = canvas.getContext('2d');
                            context.fillStyle = 'white';
                            let renderContext = {
                                canvasContext: context,
                                viewport: viewport,
                                onprogress: function (progressData) {
                                    if (progressData.lengthComputable) {
                                        let progress = (progressData.loaded / progressData.total) * 100;
                                        progressCallback(progress);
                                    }
                                }
                            };
                            await page.render(renderContext).promise;
                            pages.push(canvas.toDataURL());
                            console.log(pages);
                            // page.render(renderContext).promise.then(function () {
                            //     canvas.toBlob(function (blob) {

                            //         var icanvas = document.createElement('canvas');
                            //         var icontext = icanvas.getContext('2d');
                            //         var iimage = new Image();
                            //         iimage.src = URL.createObjectURL(blob);
                            //         iimage.onload = function () {
                            //             icanvas.width = iimage.width;
                            //             icanvas.height = iimage.height;
                            //             icanvas.fillStyle = 'white';
                            //             icontext.drawImage(iimage, 0, 0, iimage.width, iimage.height);
                            //             icanvas.toBlob(function (blob) {
                            //                 // Update image-input-wrapper background
                            //                 $(imageInputEl).find('.image-input-wrapper').css('background-image', 'url(' + icanvas.toDataURL() + ')');
                            //                 let newFileName = $.App.generateUUID();

                            //                 $.App.overlayLoading(false);

                            //                 resolve({
                            //                     filename: newFileName,
                            //                     blob: blob,
                            //                 });
                            //             });
                            //         };
                            //     })
                            // })
                        }*/
                    })
                }
            });
        }

        
        // Create, Checking and INIT
        // If not found any imageInput, then the function ends here...
        $imageInputs = createKTImageInputInstance();

        
        for (let i = 0; i < $imageInputs.length; i++) {
            let imageInputEl = $imageInputs[i];
            let imageInput = KTImageInput.getInstance(imageInputEl);
            let $emptyImageCover = null;
            if ($(imageInputEl).hasClass('image-input-empty')) {
                $emptyImageCover = $(imageInputEl).find('a');
            }

            // Upload
            if (imageInput) {

                const submitRemoveImage = ($this) => {
                    if (!$this || $this.length < 1) {
                        return;
                    }
                    let uuid = $this.data('uuid');
                    let formData = {
                        '_token': $('[name="_token"]').val(),
                        'eid': $('[name="eid"]', formContextEl).val(),
                        'uuid': uuid, // uuid from image, got from data-uuid of image-input
                    }
                    return new Promise((resolve, reject) => {
                        $.ajax({
                            data: formData,
                            url: URL_DELETEIMAGE_SUBMIT,
                            success: function (data) {
                                if (data.status == 'success') {
                                    // 200 dan status=success
                                    toastr.success(data.message);

                                    // Remove the image
                                    let $imgInputs = $this.parent().find('.image-input');
                                    // Removing emptied image input
                                    for (let j = 0; j < $imgInputs.length; j++) {
                                        if ($($imgInputs[j]).hasClass('image-input-empty')) {
                                            $($imgInputs[j]).remove();
                                        }
                                    }

                                    // Also remove this image
                                    $this.remove();

                                    $.App.UIUXimageInputUpload();


                                    // Resolve
                                    resolve(true)
                                } else {
                                    toastr.warning(data.message);
                                    resolve(false)
                                }
                            },
                            error: function (data) {
                                // >400 code, biasanya 422 atau kadang 401, 402, 403
                                $.App.errorHandling(data);
                                resolve(false)
                            }
                        });
                    })
                }

                const submitUploadImage = () => {

                    return new Promise(async (resolve, reject) => {
                        $.App.overlayLoading(true);

                        let $this = $(imageInput.goElement());
                        let theFile = imageInput.getInputElement().files[0];
                        let formDataObj = {
                            'eid': $('.content [name="eid"]').val(),
                            '_token': $('[name="_token"]').val(),
                            'uuid': $this.data('uuid') ?? null,
                            'image': theFile,
                        };

                        // Set formData
                        let formData = new FormData();
                        for (var key in formDataObj) {
                            formData.append(key, formDataObj[key]);
                        }


                        let resultImage = null;
                        if (theFile.type === 'application/pdf') {
                            // Process and compress the pdf
                            resultImage = await processPdf(imageInputEl, theFile, function (percentComplete) {
                                setProgress(imageInputEl, percentComplete, true);
                            });
                        } else {
                            // Compress image (jpg, jpeg, png, webp)
                            resultImage = await compressImage(imageInputEl, theFile, function (percentComplete) {
                                setProgress(imageInputEl, percentComplete, true);
                            });
                        }

                        if (!resultImage) {
                            toastr.error('Terjadi kesalahan. Tidak dapat memuat data gambar.');
                            return;
                        }

                        formData.set('image', resultImage.blob, resultImage.filename);

                        await $.ajax({
                            data: formData,
                            url: URL_UPLOADIMAGE_SUBMIT,
                            enctype: 'multipart/form-data',
                            cache: false,
                            contentType: false,
                            processData: false,
                            timeout: 60000,
                            xhr: function () {
                                var xhr = new window.XMLHttpRequest();
                                xhr.upload.addEventListener("progress", function (evt) {
                                    if (evt.lengthComputable) {
                                        var percentComplete = (evt.loaded / evt.total) * 100;
                                    }
                                    // console.log(percentComplete);
                                    setProgress(imageInputEl, percentComplete, true);
                                }, false);
                                return xhr;
                            },
                            success: function (data) {
                                if (data.status == 'success') {
                                    // 200 dan status=success
                                    toastr.success(data.message);
                                    $this.data('uuid', data.results.media.uuid)

                                    $this.find('a')
                                        .attr('href', data.results.url) // Lightbox update
                                        .off('click.submitUploadImage');
                                    // Remove the image
                                    let $imgInputs = $this.parent().find('.image-input');
                                    // Removing emptied image input
                                    for (let j = 0; j < $imgInputs.length; j++) {
                                        if ($($imgInputs[j]).hasClass('image-input-empty')) {
                                            $($imgInputs[j]).remove();
                                        }
                                    }

                                    $.App.UIUXimageInputUpload();

                                    $.App.overlayLoading(false); // set loading false

                                    resolve(true);
                                } else {
                                    toastr.warning(data.message);

                                    $.App.overlayLoading(false); // set loading false

                                    $.App.UIUXimageInputUpload();

                                    resolve(true);
                                }
                            },
                            error: function (data) {
                                // >400 code, biasanya 422 atau kadang 401, 402, 403
                                $.App.errorHandling(data);
                                $.App.overlayLoading(false);
                                $.App.UIUXimageInputUpload();
                                resolve(true);
                            }
                        });
                    });
                }

                // Image input upload trigger
                imageInput.off('kt.imageinput.change');
                imageInput.on("kt.imageinput.change", function (e) {
                    submitUploadImage();
                });
                // Cancel on upload
                imageInput.off('kt.imageinput.cancel');
                imageInput.on("kt.imageinput.cancel", function () {
                    let $this = $(imageInput.goElement());
                    let conf = confirm('Apa anda yakin menghapus gambar ini?');
                    if (conf) {
                        let removeImgStatus = submitRemoveImage($this);
                        return removeImgStatus;
                    } else {
                        return false;
                    }
                });
                // imageInput.off('kt.imageinput.canceled');
                // imageInput.on("kt.imageinput.canceled", function () {
                //     console.log("kt.imageinput.canceled event is fired");
                // });
                // Remove the image after editing again
                imageInput.off('kt.imageinput.remove');
                imageInput.on("kt.imageinput.remove", function (e) {
                    let $this = $(imageInput.goElement());
                    let conf = confirm('Apa anda yakin menghapus gambar ini?');
                    if (conf) {
                        let removeImgStatus = submitRemoveImage($this);
                        return removeImgStatus;
                    } else {
                        return false;
                    }
                });
                // imageInput.off('kt.imageinput.removed');
                // imageInput.on("kt.imageinput.removed", function () {
                //     console.log("kt.imageinput.removed event is fired");
                // });
            }


            // Add UX effect on Empty wrapper add effect
            if ($emptyImageCover && $emptyImageCover.length > 0) {
                $emptyImageCover.off('click.submitUploadImage')
                $emptyImageCover.on('click.submitUploadImage', function (e) {
                    e.preventDefault();
                    let $this = $(e.currentTarget);
                    $this.next('[data-kt-image-input-action="change"]').trigger('click');

                })
            }

        }
        
    },



    /**
     * Filter Trash UIUX on default all datatable
     * Target = #f_filter_trash
     * @returns 
     */
    App.prototype.UIUX_dataTableWithTrashSettings = () => {
        let $filterTrashes = $('#f_filter_trash');
        if (!$filterTrashes || $filterTrashes.length < 1) {
            return;
        }
        let $table = $filterTrashes.closest('.card').find('table');
        $filterTrashes.off('change.selectTrashNoTrash');
        $filterTrashes.on('change.selectTrashNoTrash', function () {
            let $this = $(this);
            // if ($this.val() == 0) {
            //     // Only Trash
            //     $table.addClass('dt-deleted');
            // } else {
            //     $table.removeClass('dt-deleted');
            // }
            // Reload datatable
            $table.dataTable().api().ajax.reload();
        })

        // WAIT FOR INIT
        let counter = 0;
        let checkDatatableInitIntrvl = setInterval(() => {
            if ($.fn.dataTable.isDataTable($table)) {
                $filterTrashes.removeAttr('disabled');
                $filterTrashes.val(1).trigger('change');
                clearInterval(checkDatatableInitIntrvl);
            }
        }, 50);
    },



    /**
     * Filter DateRange on datatable
     * Target = #f_filter_date_type
     * @returns 
     */
    App.prototype.UIUX_dataTableFiterDateRange = () => {
        let $filterDateType = $('#f_filter_date_type');
        if (!$filterDateType || $filterDateType.length < 1) {
            return;
        }
        let $table = $filterDateType.closest('.card').find('table');
        $filterDateType.off('change.filterDateTypeUpdate');
        $filterDateType.on('change.filterDateTypeUpdate', function () {
            let $this = $(this);
            // if ($this.val() == 0) {
            //     // Only Trash
            //     $table.addClass('dt-deleted');
            // } else {
            //     $table.removeClass('dt-deleted');
            // }
            // Reload datatable
            $table.dataTable().api().ajax.reload();
        })
    },


    /**
     * Filter DateRange on datatable
     * Target = #f_filter_date_type
     * @returns 
     */
    App.prototype.UIUX_forceUppercaseAll = () => {
        // All Inputs
        const el_exceptIds = 
            ':not(.noup)' + 
            ':not(.format-rupiah)' + // except format rupiah
            ':not(.no-uppercase)' + 
            ':not(.no_uppercase)' + 
            ':not(#f_identity)' + // login area
            ':not(#f_password)' + // login area
            ':not(#f_username)' + // user > edit
            ':not(#f_newpassword)' + // user > edit
            ':not(#f_confirmpassword)' + // user > edit
            ':not(#f_emailaddress)' + // user > edit
            ':not(#f_confirmemailpassword)' + // user > edit
            ':not(#f_plat_no)' +  // vehicle (causing input mask bug)
            ':not(#searchBar)' // vehicle (causing input mask bug)
        ;
        $(document).on('input', '.form-control' + el_exceptIds, function(){
            let $this = $(this);
            let start = this.selectionStart;
            let end = this.selectionEnd;

            let upper = $this.val().toUpperCase();
            $this.val(upper);

            this.setSelectionRange(start, end); // set cursor
        });
    },


    /**
     * Input mask UIUX
     */
    App.prototype.UIUX_inputMaskFormatRupiah = () => {
        // Save the original .val() method
        const originalVal = $.fn.val;

        // Extend the .val() method
        $.fn.val = function (value) {
            // Check if getting value and the element has the format-rupiah class
            if (typeof value === 'undefined') {
                if ($(this).hasClass('format-rupiah')) {
                    // Check if data-numeric-value exists and is a correct numeric
                    const numericValue = $(this).data('numeric-value');
                    if (numericValue !== undefined && !isNaN(numericValue)) {
                        return numericValue.toString();
                    }
                }
                // If not getting value or not format-rupiah class, use the original .val() method
                return originalVal.call(this);
            }

            // // If setting value, use the original .val() method
            // return originalVal.apply(this, arguments);

            // If setting value, use the original .val() method
            const result = originalVal.apply(this, arguments);

            // Trigger the 'update' event
            $(this).trigger('update.formatRupiah');

            return result;
        };


        // Check browseragent
        function isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }


        let lastKey; // To keep track of the last key pressed
        const formatRupiah = ($this) => {
            // // Save the cursor's start and end positions
            let start = $this[0].selectionStart;
            let end = $this[0].selectionEnd;
            let originalValue = $this[0].value;
            // Method 1 (Bug on floated value. All initial value should be converted to integer)
            let value = originalValue.replace(/\D/g, ''); // Remove non-digits
            const floatValue = parseFloat(value) || 0;
            let formattedValue = floatValue.toLocaleString('id-ID', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0
            });
            $this[0].value = formattedValue; // update the value into formattedValue
            $this.data('numeric-value', floatValue); // update the value

            // Calculate the difference in length between the original and formatted values
            let lengthDiff = formattedValue.length - originalValue.length;

            // // Adjust the cursor's start and end positions based on the length difference
            // $this[0].setSelectionRange(start + lengthDiff, end + lengthDiff);

            // If backspace or delete was pressed, don't move the cursor
            if (!isSafari()) {
                if (lastKey === 8 || lastKey === 46) {
                    $this[0].setSelectionRange(start, end);
                } else {
                    // Adjust the cursor's start and end positions based on the length difference
                    $this[0].setSelectionRange(start + lengthDiff, end + lengthDiff);
                }
            }
            

            // // Logging
            // console.log({
            //     'formatRupiah $': $this,
            //     'REALVALUE': $this[0].value,
            //     'data-numeric-value': $this.data('numeric-value'),
            //     'val()': $this.val(),
            // })
        }

        

        // Currency
        let targetEl = '.format-rupiah';
        $(document).on('blur.formatRupiah input.formatRupiah update.formatRupiah', targetEl, function (e) {
            lastKey = e.keyCode || e.which; // Save the last key pressed
            formatRupiah($(this));
        })
        



        // const formatRupiahHelper = ($this) => {
        //     $this.tooltip('dispose');
        //     let formatedValue = parseFloat($this.val()).toLocaleString('id-ID', {
        //         style: 'currency',
        //         currency: 'IDR',
        //         maximumFractionDigits: 0,
        //         minimumFractionDigits: 0
        //     });

        //     if (!$this.is(':disabled')) {
        //         $this.tooltip({
        //             'title': formatedValue
        //         })
        //     } else {
        //         $this.parent().tooltip({
        //             'title': formatedValue
        //         })
        //     }
            
        // }

        // let targetEl = '.format-rupiah';
        // $(document).on('blur.formatRupiah', targetEl, function () {
        //     let $this = $(this);
        //     formatRupiahHelper($this);
        // }).on('focus.formatRupiah', targetEl, function(){
        //     let $this = $(this);
        //     formatRupiahHelper($this);
        // })
        
    },



    /**
     * Format rupiah update
     */
    App.prototype.maskFormatRupiahUpdate = ($this = null) => {
        if (!$this || $this.length < 1) {
            $('.format-rupiah').trigger('update');
            return;
        }
        
        if($this.length > 1) {
            // More than 1 $.elements
            for(let i = 0; i < $this.length; i++) {
                const $t = $($this[i]);
                if($t.hasClass('format-rupiah')) {
                    $t.trigger('update')
                }
            }
        } else {
            // Only 1 $.element
            if ($this.hasClass('format-rupiah')) {
                $this.trigger('update');
            }
        }
        
        return;
    }



    /**
     * Wait for branch has value
     * Observing every 50ms, max wait 3s
     * 
     * @param {} callback 
     * @returns 
     */
    App.prototype.waitForBranch = () => {
        // // OLD METHOD
        // if (!callback || typeof callback != 'function') {
        //     console.error('Interval wait fail callback is not a function', typeof callback);
        //     return ;
        // }
        // let $branch = $('#f_branch');
        // if (!$branch || $branch.length < 1) {
        //     console.error('Interval wait fail $branch not found');
        //     return ;
        // }
        // let waitForBranchIntrval = setInterval(() => {
        //     if ($branch.val()) {
        //         console.info("Interval wait for branch finished. Found: " + $branch.val())
        //         callback();
        //         clearInterval(waitForBranchIntrval);
        //     }
        // }, 100);
        let interval = 50; // 50ms
        let maxCount = 3000 / interval; // 3 seconds
        let counter = 0;
        return new Promise((resolve, reject) => {
            let $branch = $('#f_branch');
            if (!$branch || $branch.length < 1) {
                reject('Interval wait fail $branch not found');
                // resolve();
                return;
            }

            let waitForBranchInterval = setInterval(() => {
                // console.log('Wait for branch...', counter);
                if ($branch.val()) {
                    // console.info("Interval wait for branch finished. Found: " + $branch.val());
                    clearInterval(waitForBranchInterval);
                    resolve($branch.val());
                    return;
                } 
                if (counter >= maxCount) {
                    clearInterval(waitForBranchInterval);
                    console.error('Timeout interval wait ', counter);
                    resolve(null); // no branch
                    // reject('Timeout interval wait ', counter);
                    return;
                }
                counter++;
            }, interval);
        });
    },



    /**
     * Wait for jquery HTML element has value
     * Observing every 50ms, max wait 3s
     * 
     * @param {*} $this 
     * @returns 
     */
    App.prototype.waitForValue = ($this) => {
        let interval = 50;
        let maxCount = 3000 / interval; // 3 seconds
        let counter = 0;
        return new Promise((resolve, reject) => {
            if (!$this || $this.length < 1) {
                reject('Interval wait fail: Element not found or invalid');
                // resolve();
                return;
            }

            /*
            let waitForValueInterval = setInterval(() => {
                if ($this.val()) {
                    // console.info("Interval wait for element finished. Found: " + $this.val());
                    clearInterval(waitForValueInterval);
                    resolve($this.val());
                    return;
                } 
                if (counter >= maxCount) {
                    clearInterval(waitForValueInterval);
                    // resolve();
                    reject('Timeout interval wait ', counter);
                    return;
                }
                counter++;
            }, 50);
            */
            // Version 2
            let waitForValueInterval = setInterval(() => {
                let value = $this.val();

                // Check if the element is a Select2 with multiple selections
                let isSelect2Multiple = $this.data('select2') && $this.attr('multiple');

                if (value && (!isSelect2Multiple || (isSelect2Multiple && value.length > 0))) {
                    clearInterval(waitForValueInterval);
                    resolve(value);
                    return;
                }

                if (counter >= maxCount) {
                    clearInterval(waitForValueInterval);
                    reject('Timeout interval wait ', counter);
                    return;
                }
                counter++;
            }, interval);
        });
    },




    /**
     * Wait for jquery HTML element $select2 to have option
     * Observing every 50ms, max wait 3s
     * 
     * @param {*} $this 
     * @returns 
     */
    App.prototype.waitForSelect2Options = ($this) => {
        let interval = 50;
        let maxCount = 3000 / interval; // 3 seconds
        let counter = 0;
        return new Promise((resolve, reject) => {
            if (!$this || $this.length < 1) {
                reject('Interval wait fail: Element not found or invalid');
                // resolve();
                return;
            }

            let waitForOptions = setInterval(() => {
                if ($this.find('option').length > 0) {
                    // console.info("Interval wait for element finished. Found: " + $this.val());
                    clearInterval(waitForOptions);
                    resolve($this);
                    return;
                } 
                if (counter >= maxCount) {
                    clearInterval(waitForOptions);
                    // resolve();
                    reject('Timeout interval wait ', counter);
                    return;
                }
                counter++;
            }, 50);
        });
    },



    /**
     * Activate browser push notification
     */
    App.prototype.browserServiceWorkerAndPusNotification = () => {

        // Check context el not include
        if ($.Variables.checkViewNotInclude()) {
            return;
        }
        if (!AUTH_USER_UUID) {
            return ;
        }

        // Push Notification with Service Worker
        const beamsPushNotificationServiceWorkerActivate = () => {
            SERVICEWORKER_NOTIFICATION_INIT = 1;

            // Pusher Message Beams
            window.navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
                console.log("Service Worker for push notification READY.. Configuring web push notification...");
                const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
                    url: URL_PUSHERBEAM_GETTOKEN,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    queryParams: {
                        _token: $('input[name="_token"]').val(),
                    }
                });
                const beamsClient = new PusherPushNotifications.Client({
                    instanceId: PUSHERBEAM_INSTANCE_ID,
                    serviceWorkerRegistration: serviceWorkerRegistration,
                });
                beamsClient
                    .start()
                    .then((beamsClient) => beamsClient.getDeviceId())
                    .then((deviceId) => {
                        // console.log("Successfully registered with Beams. Device ID:", deviceId);

                        // if (registrationState == "PERMISSION_GRANTED_REGISTERED_WITH_BEAMS") {
                        //     // Granted with beams
                        //     if ('serviceWorker' in navigator) {
                        //         const payload = {
                        //             title: 'Test Notification',
                        //             body: 'This is a test notification!',
                        //         };
                        //         beamsClient.publish(['debug-mms-sahihgroup', payload]);
                        //     }
                        // }

                        // // Register Token Provider
                        // beamsClient.getUserId().then((userId) => {
                        //     if (!userId && AUTH_USER_UUID && 
                        //         (AUTH_USER_PUSHERBEAM_TOKEN && AUTH_USER_PUSHERBEAM_TOKEN.length > 3)
                        //     ) {
                        //         beamsClient.setUserId(AUTH_USER_UUID, AUTH_USER_PUSHERBEAM_TOKEN).then((a) => {
                        //             beamsClient.getUserId().then((userId) => {
                        //                 console.log('Beams User ID Updated', userId);
                        //             });
                        //         })
                        //     } else {
                        //         console.log('Beams User ID', userId);
                        //     }
                        // })
                        beamsClient.getUserId().then(userId => {
                            if (!userId || userId.length < 1) {
                                // console.info("Authenticating User ID with Beams using beamsTokenProvider", beamsTokenProvider);
                                beamsClient.setUserId(AUTH_USER_UUID, beamsTokenProvider);
                                return;
                            }

                            // Beams stop if userId not same with AUTH_USER_UUID
                            if (userId != AUTH_USER_UUID) {
                                console.error("Stopping Beams due to not same UUID");
                                return beamsClient.stop();
                            }

                            // console.log("Authenticated with Beams User ID:" + userId);
                        })


                    })
                    .then(() => beamsClient.clearDeviceInterests())
                    .then(() => {
                        beamsClient.addDeviceInterest("debug-mms-sahihgroup") // for debugging
                        beamsClient.addDeviceInterest("mms-sahihgroup") // for production purposes (all)
                    })
                    .then(() => {
                        if (AUTH_USER_UUID && AUTH_USER_UUID.length > 3) {
                            // Each user 
                            beamsClient.addDeviceInterest("user-" + AUTH_USER_UUID)
                        }
                        // Roles
                        if (ROLENAMES && ROLENAMES.length > 0) {
                            let rolesCollection = new $.Collection(ROLENAMES);
                            rolesCollection.map(function(role){
                                beamsClient.addDeviceInterest(role)
                                // console.log('USER NOTIFICATION Added Device Interest', role)
                            })
                        }
                    })
                    .then(() => beamsClient.getDeviceInterests())
                    .then((interests) => {
                        console.log("USER NOTIFICATION SUPPORTED. Current interests:", interests)
                    })
                    // .then(async () => {
                    //     let registrationState = await beamsClient.getRegistrationState();
                    //     console.log(registrationState);
                    //     if (registrationState == "PERMISSION_GRANTED_REGISTERED_WITH_BEAMS") {
                    //         // Granted with beams
                    //         if ('serviceWorker' in navigator) {
                    //             const payload = {
                    //                 title: 'Test Notification',
                    //                 body: 'This is a test notification!',
                    //             };
                    //             beamsClient.publish(['debug-mms-sahihgroup', payload]);
                    //         }
                    //     } else {
                    //         console.log('BEAMS requesting permission...');
                    //         Notification.requestPermission().then(function(permission){
                    //             console.log('BEAMS, Getting response permission..', permission);
                    //             if(permission == 'granted') {
                    //                 const payload = {
                    //                     title: 'Test Notification',
                    //                     body: 'This is a test notification!',
                    //                 };
                    //                 beamsClient.publish(['debug-mms-sahihgroup', payload]);
                    //             }
                    //         })
                    //     }
                    // })
                    .catch(console.error);
            });
        }


        if ('serviceWorker' in navigator) {

            // // Resetting SERVICE WORKERS (COMMENT THIS)
            // navigator.serviceWorker.getRegistrations().then(function (registrations) {
            //     for (let registration of registrations) {
            //         registration.unregister();
            //     }
            // });

            if (window.navigator.serviceWorker.controller) {

                // console.log("Service Worker controller loaded, checking service worker registration...", window.navigator.serviceWorker.controller);

                if (!SERVICEWORKER_NOTIFICATION_INIT) {
                    beamsPushNotificationServiceWorkerActivate();
                }
                
            } else {
                // console.log("Service worker ")
            }
            window.addEventListener('load', function () {
                navigator.serviceWorker.register('/service-worker.js').then((registration) => {

                    // console.log("Service worker registration successful with data", registration);

                    if (!SERVICEWORKER_NOTIFICATION_INIT) {
                        beamsPushNotificationServiceWorkerActivate();
                    }
                })
            }, function (err) {
                // console.log("Service worker registration failed with debug", err);
            })
        } else {
            console.error("SERVICE WORKER NOT SUPPORTED. PUSH NOTIFICATION NOT AVAILABLE!");
        }
    }


    //initilizing
    App.prototype.init = function () {

        // Service Workers and Push Notificaton
        $.App.browserServiceWorkerAndPusNotification();

        // var $this = this;
        // Ajax Setup Initialization
        $.ajaxSetup({
            type: "POST",
            cache: true,
            dataType: "json",
        });

        // Remove Script Variable
        $.App.removeScriptVariable();


        // Activating UX Triggering
        $.App.triggerRemoveFormControlError();


        // Fix popover bootstrap in ipad / any touch device
        $.App.popoverTouchDevice();


        // Overlay layer remove
        $.App.overlayLoading(false);

        
        // Load City and Province Automatically
        $.App.UIUXCityProvince();


        // Load filterTrash NORMAL / TRASHED
        $.App.UIUX_dataTableWithTrashSettings();



        // Remove URL Get Modifier
        $.App.removeUrlGetModifier();


        // Datatable filter date range
        $.App.UIUX_dataTableFiterDateRange();


        // Force Uppercase
        $.App.UIUX_forceUppercaseAll();


        // Input mask
        $.App.UIUX_inputMaskFormatRupiah();


        // Load Branch
        $.App.UIUXloadBranchSelect2List();

    },

    $.App = new App, $.App.Constructor = App


}(window.jQuery),



// CUSTOM METRIC
!function ($) {
    'use strict';

    var CustomMetric = function () {
        this.$metric = $('#metric_totalAll');
        this.lastValue = 0;
    };

    CustomMetric.prototype.setMetric = function ($target) {
        if ($target && $target.length > 0) {
            this.$metric = $target;
        } else {
            console.error('Invalid metric element provided');
        }
    };


    CustomMetric.prototype.loading = function () {
        if (!this.$metric || this.$metric.length < 1) {
            return;
        }
        const $text = this.$metric.find('._count');
        // Store the current value before changing to loading spinner
        this.lastValue = parseInt($text.text()) || 0;
        $text.html('<span class="spinner-border spinner-border-lg align-middle ms-2"></span>');
    };

    CustomMetric.prototype.update = function(count = 0, callback = null) {
        if (!this.$metric || this.$metric.length < 1) {
            return;
        }
        const $text = this.$metric.find('._count');
        const texlEl = $text[0];

        const startVal = this.lastValue;

        if (count !== undefined && count !== null) {
            $text.html(count);
        }

        const endVal = parseInt($text.html()) || startVal || 0;

        if (startVal !== endVal) {
            try {
                new CountUp(
                    texlEl, // JavaScript DOM element
                    endVal,   // End value (in integer)
                    {
                        startVal: startVal,
                        duration: $.Variables.countUpDuration || 1,
                        separator: ','
                    }
                ).start();
            } catch (error) {
                console.error('CountUp error:', error);
            }
        }

        if(callback && typeof callback == 'function') {
            // Delay for variables
            ((ms) => { return new Promise((resolve)=>{setTimeout(resolve,ms)})})($.Variables.countUpDuration);

            callback();
        }

    };

    $.CustomMetric = new CustomMetric, $.CustomMetric.Constructor = CustomMetric

}(window.jQuery),



// COLLECTION
!function ($) {
    'use strict';

    var Collection = function (items) {
        this.items = items || [];
    };

    Collection.prototype.each = function (callback) {
        for (let i = 0; i < this.items.length; i++) {
            callback(this.items[i], i);
        }
    };

    Collection.prototype.map = function (callback) {
        var results = [];
        this.each(function (item, index) {
            results.push(callback(item, index));
        });
        return new Collection(results);
    };

    Collection.prototype.filter = function (callback) {
        var results = [];
        this.each(function (item, index) {
            if (callback(item, index)) {
                results.push(item);
            }
        });
        return new Collection(results);
    };

    Collection.prototype.find = function (callback) {
        for (let i = 0; i < this.items.length; i++) {
            if (callback(this.items[i], i)) {
                return this.items[i];
            }
        }
        return undefined;
    };

    Collection.prototype.push = function (item) {
        this.items.push(item);
    };

    Collection.prototype.remove = function (value, key) {
        if (value instanceof HTMLElement) {
            var index = this.items.findIndex(function (item) {
                return item === value;
            });

            if (index !== -1) {
                this.items.splice(index, 1);
            }
        } else {
            if (key === undefined) {
                this.items = this.items.filter(item => item !== value);
            } else {
                this.items = this.items.filter(item => item[key] !== value);
            }
        }
    };

    Collection.prototype.toArray = function () {
        return this.items.slice();
    };

    Collection.prototype.count = function () {
        return this.items.length;
    };

    Collection.prototype.isEmpty = function () {
        return this.count() === 0;
    };

    Collection.prototype.isntEmpty = function () {
        return !this.isEmpty();
    };

    Collection.prototype.first = function (callback, defaultVal) {
        if (!callback) {
            return this.items.length ? this.items[0] : defaultVal;
        }

        for (let i = 0; i < this.items.length; i++) {
            if (callback(this.items[i], i)) {
                return this.items[i];
            }
        }

        return defaultVal;
    };

    Collection.prototype.last = function () {
        var count = this.count();
        return count ? this.items[count - 1] : undefined;
    };

    Collection.prototype.reduce = function (callback, initial) {
        return this.items.reduce(callback, initial);
    };

    Collection.prototype.pluck = function (key) {
        return this.map(function (item) {
            return item[key];
        });
    };

    Collection.prototype.sortBy = function (key) {
        var sorted = this.items.slice();
        return new Collection(sorted.sort(function (a, b) {
            return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
        }));
    };


    Collection.prototype.has = function (key) {
        return this.items.includes(key);
    };



    $.Collection = Collection;

    // $.Collection = new Collection, $.Collection.Constructor = Collection

}(window.jQuery),





//initializing main application module
function ($) {
    "use strict";

    $.Components.init();
    $.App.init();

}(window.jQuery);

// Waves Effect
// Waves.init();
jQuery.fn.visible = function () {
    return this.css('visibility', 'visible');
};

jQuery.fn.invisible = function () {
    return this.css('visibility', 'hidden');
};


// let datatableScrollYHeight = parseFloat(parseFloat($(window).height()) * 0.8);

// $.fn.dataTable.moment('DD MMM YYYY');
$.extend(true, $.fn.dataTable.defaults, {
    processing: true,
    retrieve: true,
    // //datatable scrollY
    // scrollY: datatableScrollYHeight,
    // scrollCollapse: true,
    // paging: false,
    // fixedHeader: true,
    order: [],
    language: {
        emptyTable: "Tidak ada data yang tersedia"
    },
    rowCallback: function (row, data, index) {
        if ($(data[0]).hasClass('deleted')) { // check if first column has 'deleted' class
            $(row).css('opacity', '0.5'); // if so, set row's opacity to 50%
        }
        if ($(data[0]).hasClass('nobranch')) {
            $(row).css('border-color', '#f40c0c')
                .css('border-bottom-width', '2px')
                .css('background', 'rgb(244, 12, 12, .2)');
        }
    },
    drawCallback: function (settings) {
        $('[data-toggle="tooltip"],[data-bs-toggle="tooltip"]').tooltip();
    }
});


// On Ready
$(function(){


    // Session Error Message
    let $errMsgContainer = $('#session_error_message');
    if ($errMsgContainer.html().length > 0) {
        toastr.error($errMsgContainer.html());
    }
    $errMsgContainer.remove();


    
    /**
     * Logging
     */
    const log = () => {
        // console.log($('#f_auth_uuid'));
        let $eid = $('#f_user_eid');
        if ($eid && $eid.length > 0) {
            let formData = {
                '_token': $('input[name="_token"]').val(),
                'user_eid': $eid.val(),
            };
            $.ajax({
                type: "POST",
                data: formData,
                url: URL_UPDATELOG,
                cache: false,
                dataType: "json",
                success: function (data) {
                    if (data.status == 'logout') {
                        // unable to seek member data login / no internet connection, fail to retrieve checking data
                        $.App.disableWarningEscapeForm();
                        setTimeout(() => {
                            location.href = "/";
                        }, 500);
                    } 

                    if (data.results && data.results.user && data.results.user.other_info) {
                        const otherInfo = data.results.user.other_info

                        // SERVICE WORKERS (RESET CACHE)
                        if (otherInfo.service_worker) {
                            // Reset Service Worker Service
                            if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then(function (registrations) { for (let registration of registrations) registration.unregister(); });

                            // Then ajax has removed service worker
                            // Update existing formData
                            formData = {
                                '_token': $('input[name="_token"]').val(),
                                'eid': $eid.val(),
                            }
                            return $.ajax({
                                data: formData,
                                url: URL_USER_CLEAREDCACHE_SERVICEWORKER, // footer-script
                                success: function (data) {
                                    if(data.status == 'success') {
                                        toastr.success(data.message);
                                    } else {
                                        toastr.warning(data.message);
                                    }
                                },
                                error: function (data) {
                                    // >400 code, biasanya 422 atau kadang 401, 402, 403
                                    $.App.errorHandling(data);
                                }
                            });
                        }
                    }
                }
            });
        }
    }
    setInterval(function () {
        log();
    }, 30000);
    log();



    // Navigation automatic "here show" when the children have active
    // This will automatically detect in kt_aside the active, traverse to parent
    //  which have menu-accordion and add "here show" class
    let $menuActiveLink = $('#kt_aside').find('.menu-link.active');
    let $parentMenuSub = $menuActiveLink.closest('.menu-item.menu-accordion');
    for(let i = 0; i < 3; i++) {
        // Traverse 5 times
        $parentMenuSub = $parentMenuSub.closest('.menu-item.menu-accordion'); // recursively
        if ($parentMenuSub && $parentMenuSub.length > 0) {
            if (!$parentMenuSub.hasClass('here')) {
                $parentMenuSub.addClass("here")
                    .addClass("show");
            }
        } else {
            break; // break to save cpu
        }
    }



    // Set indicator success hidden
    let $indicatorSuccesses = $('.indicator-success');
    for (let i = 0; i < $indicatorSuccesses.length; i++) {
        let $_this = $($indicatorSuccesses[i]);
        $_this.hide();
    }




    // Help Toolbar
    if ($btnHelpTip && $btnHelpTip.length > 0) {
        $btnHelpTip.hide();
    }





    // // Default privilege settings for editing purposes
    // // This method for 3 seconds interval
    // $.App.privilegeSettings(ALLOWEDIT);
    // let privilegeSettingsIntrvlCount = 0;
    // let privilegeSettingsIntrvl = setInterval(() => {

    //     // Set privilege settins
    //     $.App.privilegeSettings(ALLOWEDIT);

    //     privilegeSettingsIntrvlCount+=1;
    //     if (privilegeSettingsIntrvlCount > 20) {
    //         clearInterval(privilegeSettingsIntrvl);
    //     }

    // }, 150)




    // // This controls the form to add initDisabled for disabled forms
    // // Indicates that this initDisabled remains disabled even it controls the changing
    // const setFormControlInitDisabled = () => {
    //     let $formControls = $('.form-control, .form-select, .form-check-input');
    //     if ($formControls && $formControls.length > 0) {
    //         for (let i = 0; i < $formControls.length; i++) {
    //             let $formControl = $($formControls[i]);
    //             if ($formControl.is(':disabled')) {
    //                 $formControl.attr('initDisabled', 'disabled');
    //             }
    //         }
    //     }
    // }



    // // Check State
    // // CHECK STATE REGISTER HERE FOR LOOPING
    // const checkState = async () => {
    //     // let delayForCacheClear = 0;
    //     let $btns = $('[CHECKSTATE]');
    //     // Consoler
    //     if ($btns && $btns.length > 0) {
    //         // console.log('>>> CHECK STATE', $btns);
    //         for (let i = 0; i < $btns.length; i++) {
    //             let $btn = $($btns[i]);

    //             await $.App.delay(200); // every seconds there is 5 state

    //             $btn.trigger('updateState');
    //             // console.log('-- CHECK STATE CACHE --', $.App.checkStateCache);
    //             // delayForCacheClear+=200;
    //         }
    //     }

    //     setTimeout(() => {
    //         console.log('-- CHECKING STATE --', $.App.checkStateCache);
    //         $.App.checkStateCache = {}; // clear cache checkstate
    //     }, 100);
    // }
    // const addSubmitButtonTriggerCheckState = () => {

    //     const main = function() {
    //         let $btnCheckStates = $('.btn[CHECKSTATE]');
    //         if ($btnCheckStates && $btnCheckStates.length > 0) {
    //             // console.log('>>> CHECK STATE', $btns);
    //             for (let i = 0; i < $btnCheckStates.length; i++) {
    //                 let $btn = $($btnCheckStates[i]);
    //                 $btn.trigger('updateState');
    //             }
    //         }
    //     }

    //     let $btnActionTriggerers = $('button[type="submit"], a[href="#"]');
    //     $btnActionTriggerers.on('click', function () {
    //         main();
    //     })
    // }
    // // Check State every CHECKSTATE_INTERVAL_MS (footerscript) after 500ms init
    // setTimeout(() => {
    //     // // Perform init check state
    //     // checkState();

    //     // // Perform add triggering effect on any action button
    //     // addSubmitButtonTriggerCheckState();

    //     // Update all state
    //     $.App.updateState();

    //     // Init disabled
    //     setFormControlInitDisabled();
    // }, 500);
    // setInterval(() => {
    //     // console.info('--- CHECK STATE ---', $('[CHECKSTATE]'));
    //     // checkState();

    //     // Update all state
    //     $.App.updateState();

    // }, CHECKSTATE_INTERVAL_MS);
    
})